export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AdAllocationArgs = {
  id?: Maybe<Scalars['Float']>;
  entityId?: Maybe<Scalars['Float']>;
  entityType?: Maybe<AdAllocationEntityType>;
};

export type AdAllocationEntity = Team | Competition;

export enum AdAllocationEntityType {
  team = 'team',
  competition = 'competition'
}

export type AdAllocationLoopConfig = {
   __typename?: 'AdAllocationLoopConfig';
  enabled: Scalars['Boolean'];
  type: Scalars['String'];
  perPeriod: Scalars['Float'];
  secsPerShow: Scalars['Float'];
  secsBetweenShows: Scalars['Float'];
};

export type AdAllocationLoopConfigInput = {
  enabled: Scalars['Boolean'];
  type: Scalars['String'];
  perPeriod: Scalars['Float'];
  secsPerShow: Scalars['Float'];
  secsBetweenShows: Scalars['Float'];
};

export type AdAllocationTeamConfig = {
   __typename?: 'AdAllocationTeamConfig';
  home: TeamAllocationConfig;
  away: TeamAllocationConfig;
};

export type AdAllocationTeamConfigInput = {
  home: TeamAllocationConfigInput;
  away: TeamAllocationConfigInput;
};

export type AdFile = {
   __typename?: 'AdFile';
  id: Scalars['Float'];
  adSetId: Scalars['Float'];
  file?: Maybe<File>;
  size: Scalars['String'];
  adSet: AdSet;
};

export type AdminOrganizationInput = {
  id: Scalars['Float'];
  planQuantity?: Maybe<Scalars['Float']>;
  manualPayment: Scalars['Boolean'];
};

export type AdSet = {
   __typename?: 'AdSet';
  id: Scalars['Float'];
  name: Scalars['String'];
  organizationId: Scalars['Float'];
  teamId?: Maybe<Scalars['Float']>;
  adFiles: Array<AdFile>;
  adSetAllocations?: Maybe<Array<AdsetAllocation>>;
  entityAdAllocations?: Maybe<Array<EntityAdAllocation>>;
  countAdAllocations: Scalars['Float'];
  archived: Scalars['Boolean'];
};

export type AdsetAllocation = {
   __typename?: 'AdsetAllocation';
  id: Scalars['Float'];
  percentage?: Maybe<Scalars['Float']>;
  entityAdAllocationId: Scalars['Float'];
  events?: Maybe<Array<Scalars['String']>>;
  adSetId: Scalars['Float'];
  adSet: AdSet;
};

export type AdsetAllocationInput = {
  percentage?: Maybe<Scalars['Float']>;
  events?: Maybe<Array<Scalars['String']>>;
  adSetId: Scalars['Float'];
  delete?: Maybe<Scalars['Boolean']>;
};

/** Age options for competitions and teams */
export enum Age {
  U7 = 'U7',
  U8 = 'U8',
  U9 = 'U9',
  U10 = 'U10',
  U11 = 'U11',
  U12 = 'U12',
  U13 = 'U13',
  U14 = 'U14',
  U15 = 'U15',
  U16 = 'U16',
  U17 = 'U17',
  U18 = 'U18',
  U19 = 'U19',
  U20 = 'U20',
  U21 = 'U21',
  U22 = 'U22',
  U23 = 'U23',
  Adults = 'Adults',
  Senior = 'Senior'
}

export type ClockInfo = {
   __typename?: 'ClockInfo';
  clockRunning: Scalars['Boolean'];
  clockInMs: Scalars['Float'];
  clockChangeDate?: Maybe<Scalars['DateTime']>;
};

export type Club = {
   __typename?: 'Club';
  id: Scalars['Float'];
  name: Scalars['String'];
  gfxName: Scalars['String'];
  gfxFullName: Scalars['String'];
  abbreviation: Scalars['String'];
  defaultVenue?: Maybe<Venue>;
  primaryBackgroundColor?: Maybe<Scalars['String']>;
  primaryTextColor?: Maybe<Scalars['String']>;
  secondaryBackgroundColor?: Maybe<Scalars['String']>;
  secondaryTextColor?: Maybe<Scalars['String']>;
  organizationId: Scalars['Float'];
  organization: Organization;
  logo?: Maybe<File>;
  teams?: Maybe<Array<Team>>;
  archived: Scalars['Boolean'];
};

export type ClubOrTeam = Club | Team;

export type ClubTeamsInput = {
  id?: Maybe<Scalars['Float']>;
  competitions?: Maybe<Array<TeamCompetitionsInput>>;
  age: Age;
  gender: Gender;
  sportId: Scalars['Float'];
  gradeId: Scalars['Float'];
};

export type Competition = {
   __typename?: 'Competition';
  id: Scalars['Float'];
  name: Scalars['String'];
  gfxName?: Maybe<Scalars['String']>;
  matchConfig: Scalars['JSON'];
  organization: Organization;
  overlayConfig: Scalars['JSON'];
  sportId: Scalars['Float'];
  sport: Sport;
  watermark?: Maybe<File>;
  secondaryWatermark?: Maybe<File>;
  logo?: Maybe<File>;
  adAllocation?: Maybe<EntityAdAllocation>;
  baseId?: Maybe<Scalars['Float']>;
  baseEntity?: Maybe<CompetitionBase>;
  themeId: Scalars['Float'];
  theme: Theme;
  archived: Scalars['Boolean'];
  countTeams: Scalars['Float'];
  countMatches: Scalars['Float'];
  age: Age;
  gender: Gender;
  grade: Grade;
  teams: Array<Team>;
};

export type CompetitionBase = {
   __typename?: 'CompetitionBase';
  id: Scalars['Float'];
  name: Scalars['String'];
  sport: Sport;
  providerId: Scalars['Float'];
  providerName: Scalars['String'];
  matchConfig: Scalars['JSON'];
};

export type CreateAdFileInput = {
  image: Scalars['Upload'];
  size: Scalars['String'];
  adSetId: Scalars['Float'];
};

export type CreateAdSetInput = {
  name: Scalars['String'];
  teamId?: Maybe<Scalars['Float']>;
};

export type CreateClubInput = {
  name: Scalars['String'];
  gfxName: Scalars['String'];
  gfxFullName: Scalars['String'];
  abbreviation: Scalars['String'];
  defaultVenueId?: Maybe<Scalars['Float']>;
  primaryBackgroundColor: Scalars['String'];
  primaryTextColor: Scalars['String'];
  secondaryBackgroundColor?: Maybe<Scalars['String']>;
  secondaryTextColor?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['Upload']>;
};

export type CreateCompetitionInput = {
  name: Scalars['String'];
  gfxName?: Maybe<Scalars['String']>;
  sportId: Scalars['Float'];
  matchConfig?: Maybe<Scalars['JSON']>;
  overlayConfig?: Maybe<Scalars['JSON']>;
  watermark?: Maybe<Scalars['Upload']>;
  secondaryWatermark?: Maybe<Scalars['Upload']>;
  logo?: Maybe<Scalars['Upload']>;
  themeId?: Maybe<Scalars['Float']>;
  age: Age;
  gender: Gender;
  gradeId: Scalars['Float'];
};

export type CreateFactInput = {
  name: FactName;
  matchId: Scalars['Float'];
  teamId?: Maybe<Scalars['Float']>;
  playerId?: Maybe<Scalars['Float']>;
  adapter: Scalars['String'];
  sourceId?: Maybe<Scalars['String']>;
  sourceNumberFromId?: Maybe<Scalars['Float']>;
  clockMs?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  minute?: Maybe<Scalars['Float']>;
  period?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSON']>;
};

export type CreateFactsInput = {
  facts: Array<CreateFactInput>;
};

export type CreateFileInput = {
  url: Scalars['String'];
  entityId: Scalars['Float'];
  entityType: FileEntityType;
};

export type CreateMatchInput = {
  name: Scalars['String'];
  homeTeamId: Scalars['Float'];
  awayTeamId: Scalars['Float'];
  venueId: Scalars['Float'];
  competitionId: Scalars['Float'];
  date: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['JSON']>;
};

export type CreateOrganizationAdapterInput = {
  organizationId: Scalars['Float'];
  providerCompetitionId: Scalars['Float'];
  providerName: Scalars['String'];
};

export type CreateOrganizationInput = {
  name: Scalars['String'];
  logo?: Maybe<Scalars['Upload']>;
};

export type CreateOverlayInput = {
  matchId: Scalars['Float'];
  name: Scalars['String'];
  encodingDelay?: Maybe<Scalars['Float']>;
  autoMode?: Maybe<Scalars['Boolean']>;
  testMode?: Maybe<Scalars['Boolean']>;
  resolution?: Maybe<Scalars['Float']>;
  showWatermarks?: Maybe<Scalars['Boolean']>;
  background?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  enableAds?: Maybe<Scalars['Boolean']>;
};

export type CreatePlayerInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  gfxFirstName?: Maybe<Scalars['String']>;
  gfxLastName?: Maybe<Scalars['String']>;
  teams?: Maybe<Array<PlayerTeamsInput>>;
};

export type CreateTeamClubInput = {
  name: Scalars['String'];
  competitions?: Maybe<Array<TeamCompetitionsInput>>;
  sportId: Scalars['Float'];
  age: Age;
  gender: Gender;
  gradeId: Scalars['Float'];
  clubId?: Maybe<Scalars['Float']>;
};

export type CreateTeamInput = {
  name: Scalars['String'];
  gfxName?: Maybe<Scalars['String']>;
  gfxFullName?: Maybe<Scalars['String']>;
  abbreviation?: Maybe<Scalars['String']>;
  defaultVenueId?: Maybe<Scalars['Float']>;
  defaultVenue?: Maybe<CreateVenueInput>;
  primaryBackgroundColor?: Maybe<Scalars['String']>;
  primaryTextColor?: Maybe<Scalars['String']>;
  secondaryBackgroundColor?: Maybe<Scalars['String']>;
  secondaryTextColor?: Maybe<Scalars['String']>;
  competitions?: Maybe<Array<TeamCompetitionsInput>>;
  logo?: Maybe<Scalars['Upload']>;
  sportId: Scalars['Float'];
  age: Age;
  gender: Gender;
  gradeId: Scalars['Float'];
  clubId?: Maybe<Scalars['Float']>;
};

export type CreateUserInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  photo?: Maybe<Scalars['Upload']>;
};

export type CreateVenueInput = {
  name: Scalars['String'];
  gfxName?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
};

export type DateRange = {
  start?: Maybe<Scalars['DateTime']>;
  end?: Maybe<Scalars['DateTime']>;
};


export type DefaultOverlayConfig = {
   __typename?: 'DefaultOverlayConfig';
  encodingDelay?: Maybe<Scalars['Float']>;
  mode: Scalars['String'];
  resolution: Scalars['Float'];
  showWatermarks: Scalars['Boolean'];
  background: Scalars['String'];
  enableAds: Scalars['Boolean'];
};

export type DeleteFactsInput = {
  factIds: Array<Scalars['Float']>;
};

export type EditableFields = {
  image: Scalars['Upload'];
};

export enum EFinishedStatus {
  finished = 'finished',
  pregame = 'pregame',
  runningLate = 'runningLate',
  inProgress = 'inProgress',
  cancelled = 'cancelled',
  expired = 'expired'
}

export type EntityAdAllocation = {
   __typename?: 'EntityAdAllocation';
  id: Scalars['Float'];
  entityId: Scalars['Float'];
  organization: Organization;
  entityType: AdAllocationEntityType;
  entity: AdAllocationEntity;
  config?: Maybe<EntityAdAllocationConfig>;
  adSets: Array<AdSet>;
};

export type EntityAdAllocationConfig = {
   __typename?: 'EntityAdAllocationConfig';
  teams: AdAllocationTeamConfig;
  events: Scalars['JSON'];
  loop: AdAllocationLoopConfig;
};

export type EntityAdAllocationConfigInput = {
  teams: AdAllocationTeamConfigInput;
  events: Scalars['JSON'];
  loop: AdAllocationLoopConfigInput;
};

export type EntityAdAllocationInput = {
  config?: Maybe<EntityAdAllocationConfigInput>;
  adSetAllocations?: Maybe<Array<AdsetAllocationInput>>;
  entityId?: Maybe<Scalars['Float']>;
  entityType: AdAllocationEntityType;
};

export type EntityAdAllocationUpdate = {
  config?: Maybe<EntityAdAllocationConfigInput>;
  adSetAllocations?: Maybe<Array<AdsetAllocationInput>>;
  id?: Maybe<Scalars['Float']>;
  entityId?: Maybe<Scalars['Float']>;
  entityType?: Maybe<AdAllocationEntityType>;
};

export type Fact = {
   __typename?: 'Fact';
  id: Scalars['Float'];
  name: FactName;
  organizationId: Scalars['Float'];
  organization: Organization;
  matchId: Scalars['Float'];
  match: Match;
  teamId?: Maybe<Scalars['Float']>;
  team?: Maybe<Team>;
  adapter: Scalars['String'];
  sourceId?: Maybe<Scalars['String']>;
  minute?: Maybe<Scalars['Float']>;
  date: Scalars['DateTime'];
  period: Scalars['String'];
  data?: Maybe<Scalars['JSON']>;
  playerId?: Maybe<Scalars['Float']>;
  player?: Maybe<Player>;
};

export enum FactName {
  CORNER = 'CORNER',
  GOAL = 'GOAL',
  FOUL = 'FOUL',
  YELLOW_CARD = 'YELLOW_CARD',
  RED_CARD = 'RED_CARD',
  FREE_KICK = 'FREE_KICK',
  OFFSIDE = 'OFFSIDE',
  SHOT_ON_TARGET = 'SHOT_ON_TARGET',
  SHOT_OFF_TARGET = 'SHOT_OFF_TARGET',
  PENALTY_SHOOTOUT_MISS = 'PENALTY_SHOOTOUT_MISS',
  PENALTY_AWARDED = 'PENALTY_AWARDED',
  PENALTY_SHOOTOUT_GOAL = 'PENALTY_SHOOTOUT_GOAL',
  POSSESSION_CHANGED = 'POSSESSION_CHANGED',
  TRY = 'TRY',
  DROP_GOAL = 'DROP_GOAL',
  GOAL_KICK_SCORED = 'GOAL_KICK_SCORED',
  GOAL_KICK_MISSED = 'GOAL_KICK_MISSED',
  PENALTY_GOAL = 'PENALTY_GOAL',
  PENALTY_TRY = 'PENALTY_TRY',
  TRY_ASSIST = 'TRY_ASSIST',
  CONVERSION = 'CONVERSION',
  CONVERSION_MISSED = 'CONVERSION_MISSED',
  PENALTY_GOAL_MISSED = 'PENALTY_GOAL_MISSED',
  DROP_GOAL_MISSED = 'DROP_GOAL_MISSED',
  KICKING_COMP_GOALS = 'KICKING_COMP_GOALS',
  KICKING_COMP_GOALS_MISSED = 'KICKING_COMP_GOALS_MISSED',
  LINEOUT = 'LINEOUT',
  LINEOUT_CONCEDED = 'LINEOUT_CONCEDED',
  SCRUM = 'SCRUM',
  SCRUM_CONCEDED = 'SCRUM_CONCEDED',
  CLEAN_BREAK = 'CLEAN_BREAK',
  DEFENDER_BEATEN = 'DEFENDER_BEATEN',
  PENALTY_CONCEDED = 'PENALTY_CONCEDED',
  TURNOVER_CONCEDED = 'TURNOVER_CONCEDED',
  RUCK = 'RUCK',
  RUCK_CONCEDED = 'RUCK_CONCEDED',
  RESTART = 'RESTART',
  KICK = 'KICK',
  SUBSTITUTION = 'SUBSTITUTION',
  PLAYERS_ENTERING = 'PLAYERS_ENTERING',
  ABOUT_TO_START = 'ABOUT_TO_START',
  PERIOD_STARTED = 'PERIOD_STARTED',
  PERIOD_FINISHED = 'PERIOD_FINISHED',
  CLOCK_STARTED = 'CLOCK_STARTED',
  CLOCK_STOPPED = 'CLOCK_STOPPED',
  CLOCK_ADJUSTED = 'CLOCK_ADJUSTED',
  PROVIDER_CONNECTED = 'PROVIDER_CONNECTED',
  PROVIDER_DISCONNECTED = 'PROVIDER_DISCONNECTED',
  PROVIDER_CONNECTION_PROBLEMS = 'PROVIDER_CONNECTION_PROBLEMS',
  PROVIDER_MESSAGE = 'PROVIDER_MESSAGE',
  LINEUPS = 'LINEUPS',
  PLAYERS_SHAKING_HANDS = 'PLAYERS_SHAKING_HANDS',
  VIDEO_REF_DELIBERATION = 'VIDEO_REF_DELIBERATION',
  MATCH_CANCELLED = 'MATCH_CANCELLED',
  ANTHEMS = 'ANTHEMS'
}

export type File = {
   __typename?: 'File';
  id: Scalars['Float'];
  url: Scalars['String'];
  entityId: Scalars['Float'];
  entityType: FileEntityType;
};

export enum FileEntityType {
  team = 'team',
  club = 'club',
  competitionLogo = 'competitionLogo',
  competitionWatermarkPrimary = 'competitionWatermarkPrimary',
  competitionWatermarkSecondary = 'competitionWatermarkSecondary',
  adFile = 'adFile',
  player = 'player',
  teamPlayer = 'teamPlayer',
  user = 'user',
  venue = 'venue',
  organization = 'organization'
}

export type FootballStats = {
   __typename?: 'FootballStats';
  sport: Scalars['String'];
  corners: Scalars['Float'];
  fouls: Scalars['Float'];
  goals: Scalars['Float'];
  offsides: Scalars['Float'];
  penaltiesMissed: Scalars['Float'];
  penaltiesAwarded: Scalars['Float'];
  freeKicks: Scalars['Float'];
  possession: Scalars['Float'];
  redCards: Scalars['Float'];
  shotsOnTarget: Scalars['Float'];
  shotsOffTarget: Scalars['Float'];
  totalShots: Scalars['Float'];
  yellowCards: Scalars['Float'];
  substitutions: Scalars['Float'];
};

/** Gender options for competitions and teams */
export enum Gender {
  Male = 'Male',
  Female = 'Female',
  Mixed = 'Mixed'
}

export type Grade = {
   __typename?: 'Grade';
  id: Scalars['Float'];
  name: Scalars['String'];
};

export type HeartBeat = {
   __typename?: 'HeartBeat';
  serverTime: Scalars['DateTime'];
};

export type ImpersonateOutput = {
   __typename?: 'ImpersonateOutput';
  accessToken: Scalars['String'];
  userId: Scalars['Float'];
  expiry: Scalars['Float'];
  defaultOrganization?: Maybe<Organization>;
  adminId: Scalars['Float'];
};

export type InviteUserInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  role: Scalars['String'];
};

export type Invoice = {
   __typename?: 'Invoice';
  status: Scalars['String'];
  created: Scalars['DateTime'];
  dueDate: Scalars['DateTime'];
  pdfLink: Scalars['String'];
  amountDue: Scalars['Float'];
  amountPaid: Scalars['Float'];
  currency: Scalars['String'];
  stripeId: Scalars['String'];
  period: InvoicePeriod;
  plan: Scalars['String'];
};

export type InvoicePeriod = {
   __typename?: 'InvoicePeriod';
  start: Scalars['DateTime'];
  end: Scalars['DateTime'];
};

export type IQueryOptions = {
  order?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['String']>;
  endAt?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Float']>;
  offset?: Maybe<Scalars['Float']>;
  archive?: Maybe<Scalars['Boolean']>;
};

export type JoinTeamInput = {
  playerId: Scalars['Float'];
  teamId: Scalars['Float'];
  photo?: Maybe<Scalars['Upload']>;
  position?: Maybe<Scalars['String']>;
  positionType?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  defaultStarter: Scalars['Boolean'];
};


export type LoginOutput = {
   __typename?: 'LoginOutput';
  accessToken: Scalars['String'];
  userId: Scalars['Float'];
  expiry: Scalars['Float'];
  defaultOrganization?: Maybe<Organization>;
};

export type LoginOverlayOutput = {
   __typename?: 'LoginOverlayOutput';
  accessToken: Scalars['String'];
  expiry: Scalars['Float'];
  organizationId: Scalars['Float'];
};

export type LogoutOutput = {
   __typename?: 'LogoutOutput';
  success: Scalars['Boolean'];
};

export type ManualGraphicsUpdate = {
  overlayId: Scalars['Float'];
  command: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  graphicProps?: Maybe<Scalars['JSON']>;
};

export type Match = {
   __typename?: 'Match';
  id: Scalars['Float'];
  name: Scalars['String'];
  organizationId: Scalars['Float'];
  awayTeamId: Scalars['Float'];
  homeTeamId: Scalars['Float'];
  venueId: Scalars['Float'];
  competitionId: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  organization: Organization;
  homeTeam: Team;
  awayTeam: Team;
  venue: Venue;
  competition: Competition;
  overlays: Array<Overlay>;
  config: Scalars['JSON'];
  sportName: Scalars['String'];
  score: Score;
  clockData: ClockInfo;
  liveStatus: PeriodStatus;
  finishedStatus: Scalars['String'];
  coverage?: Maybe<Scalars['Boolean']>;
  currentPeriod: MatchPeriod;
  lineup: Array<MatchPlayer>;
  baseEntity?: Maybe<MatchBase>;
  facts: Array<Fact>;
  archived: Scalars['Boolean'];
  hasFacts: Scalars['Boolean'];
  summary: MatchSummary;
};

export type MatchBase = {
   __typename?: 'MatchBase';
  id: Scalars['Float'];
  name: Scalars['String'];
  baseHomeTeamId: Scalars['Float'];
  baseAwayTeamId: Scalars['Float'];
  baseVenueId: Scalars['Float'];
  baseCompetitionId: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  finishedStatus: Scalars['String'];
  coverage: Scalars['Boolean'];
  providerId: Scalars['Float'];
  providerName: Scalars['String'];
};

export type Matches = {
   __typename?: 'Matches';
  matches: Array<Match>;
  total: Scalars['Float'];
};

export type MatchesSubscriptionArgs = {
  topics?: Maybe<Array<Scalars['String']>>;
  dateRange?: Maybe<DateRange>;
  sportIds?: Maybe<Array<Scalars['Float']>>;
  competitionIds?: Maybe<Array<Scalars['Float']>>;
};

export type MatchesSubscriptionUpdates = {
   __typename?: 'MatchesSubscriptionUpdates';
  match: Match;
  topic: Scalars['String'];
  date: Scalars['DateTime'];
};

export type MatchFeedBroadcast = {
   __typename?: 'MatchFeedBroadcast';
  facts: Array<Fact>;
  topic: Scalars['String'];
  matchSummary: MatchSummary;
};

export type MatchPeriod = {
   __typename?: 'MatchPeriod';
  duration?: Maybe<Scalars['Float']>;
  number: Scalars['Float'];
  name: Scalars['String'];
  shortName: Scalars['String'];
  code: Scalars['String'];
  status: PeriodStatus;
  type: PeriodType;
  aboutToStart?: Maybe<Scalars['Boolean']>;
  playersEntered?: Maybe<Scalars['Boolean']>;
  shootout?: Maybe<Scalars['Boolean']>;
  finished?: Maybe<Scalars['DateTime']>;
  started?: Maybe<Scalars['DateTime']>;
  pregame?: Maybe<Scalars['Boolean']>;
  preOvertimeBreak?: Maybe<Scalars['Boolean']>;
  matchFinished?: Maybe<Scalars['Boolean']>;
  cancelled?: Maybe<Scalars['Boolean']>;
};

export type MatchPlayer = {
   __typename?: 'MatchPlayer';
  id: Scalars['Float'];
  teamId: Scalars['Float'];
  team: Team;
  playerId: Scalars['Float'];
  player: Player;
  matchId: Scalars['Float'];
  match: Match;
  starting?: Maybe<Scalars['Boolean']>;
  playing?: Maybe<Scalars['Boolean']>;
  captain?: Maybe<Scalars['Boolean']>;
  position?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  redCard: Scalars['Boolean'];
  photo?: Maybe<File>;
};

export type MatchStats = {
   __typename?: 'MatchStats';
  home: SportStats;
  away: SportStats;
  players: Array<PlayerStats>;
  periods: Array<PeriodStats>;
  shootoutResults?: Maybe<Array<ShootoutResults>>;
  score: Score;
};

export type MatchSubscriptionArgs = {
  id: Scalars['Float'];
  topics?: Maybe<Array<Scalars['String']>>;
};

export type MatchSummary = {
   __typename?: 'MatchSummary';
  matchId: Scalars['Float'];
  clock: ClockInfo;
  currentPeriod: Scalars['String'];
  periods: Array<MatchPeriod>;
  matchStats: MatchStats;
  match: Match;
  currentPeriodData: Match;
};

export type MatchUpdate = {
   __typename?: 'MatchUpdate';
  updated: Scalars['DateTime'];
  match: Match;
};

export type Me = {
   __typename?: 'Me';
  id: Scalars['Float'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  admin?: Maybe<Scalars['Boolean']>;
  currentOrganization?: Maybe<Organization>;
  organizations: Array<Organization>;
  photo?: Maybe<File>;
};

export type Mutation = {
   __typename?: 'Mutation';
  createAdFile: AdFile;
  updateAdFile: AdFile;
  deleteAdFile: Scalars['Boolean'];
  createAdSet: AdSet;
  updateAdSet: AdSet;
  deleteAdSet: Scalars['Boolean'];
  restoreAdSet: Scalars['Boolean'];
  login: LoginOutput;
  loginOverlay: LoginOverlayOutput;
  impersonate: ImpersonateOutput;
  unimpersonate: ImpersonateOutput;
  logout: LogoutOutput;
  createClub: Club;
  updateClub: Club;
  addTeamsToClub: Club;
  deleteClub: Scalars['Boolean'];
  restoreClub: Scalars['Boolean'];
  createCompetition: Competition;
  updateCompetition: Competition;
  updateCompetitionAdmin: Competition;
  deleteCompetition: Scalars['Boolean'];
  restoreCompetition: Scalars['Boolean'];
  updateEntityAdAllocation: Scalars['Boolean'];
  createEntityAdAllocation: EntityAdAllocation;
  createFact: MatchFeedBroadcast;
  updateFact: MatchFeedBroadcast;
  createFacts: MatchFeedBroadcast;
  deleteFact: MatchFeedBroadcast;
  deleteFacts: MatchFeedBroadcast;
  resetMatch: MatchFeedBroadcast;
  deleteFile: Scalars['Boolean'];
  toggleStarting: MatchPlayer;
  setCaptain: Array<MatchPlayer>;
  createMatch: Match;
  updateMatch: Match;
  deleteMatch: Scalars['Boolean'];
  restoreMatch: Scalars['Boolean'];
  addPlayerToLineup: Match;
  removePlayerFromLineup: Match;
  createOrganizationAdapter: OrganizationAdapter;
  deleteOrganizationAdapter: Scalars['Boolean'];
  createOrganization: Organization;
  makeDefaultOrganization: Organization;
  updateOrganization: Organization;
  toggleManualPaymentForOrganization: Organization;
  toggleBlockOrganization: Organization;
  createOverlay: Overlay;
  updateOverlay: Overlay;
  deleteOverlay: Scalars['Boolean'];
  createManualGraphicsCommand: Overlay;
  passwordReset: Scalars['Boolean'];
  updatePassword: Scalars['Boolean'];
  updatePasswordWithCurrent: Scalars['Boolean'];
  invite: UserOrganization;
  updatePermission: UserOrganization;
  transferOwnership: UserOrganization;
  revoke: Scalars['Boolean'];
  createPlayer: Player;
  joinTeam: Player;
  updatePlayer: Player;
  leaveTeam: Player;
  deletePlayer: Scalars['Boolean'];
  restorePlayer: Scalars['Boolean'];
  register: RegisterOutput;
  confirmEmail: Scalars['Boolean'];
  createOrUpdateSubscription: Organization;
  updateCard: Organization;
  cancelSubscription: Organization;
  createTeam: Team;
  updateTeam: Team;
  deleteTeam: Scalars['Boolean'];
  restoreTeam: Scalars['Boolean'];
  updateUser: User;
  changePassword: Scalars['Boolean'];
  toggleBlockUser: User;
  toggleAdminUser: User;
  createVenue: Venue;
  updateVenue: Venue;
  deleteVenue: Scalars['Boolean'];
  restoreVenue: Scalars['Boolean'];
};


export type MutationCreateAdFileArgs = {
  createAdFileInput: CreateAdFileInput;
};


export type MutationUpdateAdFileArgs = {
  updateAdFileInput: UpdateAdFileInput;
};


export type MutationDeleteAdFileArgs = {
  id: Scalars['Float'];
};


export type MutationCreateAdSetArgs = {
  createAdSetInput: CreateAdSetInput;
};


export type MutationUpdateAdSetArgs = {
  updateAdSetInput: UpdateAdSetInput;
};


export type MutationDeleteAdSetArgs = {
  id: Scalars['Float'];
};


export type MutationRestoreAdSetArgs = {
  id: Scalars['Float'];
};


export type MutationLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationLoginOverlayArgs = {
  key: Scalars['String'];
};


export type MutationImpersonateArgs = {
  id: Scalars['Float'];
};


export type MutationCreateClubArgs = {
  createClubInput: CreateClubInput;
};


export type MutationUpdateClubArgs = {
  updateClubInput: UpdateClubInput;
};


export type MutationAddTeamsToClubArgs = {
  teams: Array<ClubTeamsInput>;
  id: Scalars['Float'];
};


export type MutationDeleteClubArgs = {
  id: Scalars['Float'];
};


export type MutationRestoreClubArgs = {
  id: Scalars['Float'];
};


export type MutationCreateCompetitionArgs = {
  createCompetitionInput: CreateCompetitionInput;
};


export type MutationUpdateCompetitionArgs = {
  updateCompetitionInput: UpdateCompetitionInput;
};


export type MutationUpdateCompetitionAdminArgs = {
  updateCompetitionInput: UpdateCompetitionAdminInput;
};


export type MutationDeleteCompetitionArgs = {
  id: Scalars['Float'];
};


export type MutationRestoreCompetitionArgs = {
  id: Scalars['Float'];
};


export type MutationUpdateEntityAdAllocationArgs = {
  entityAdAllocationUpdate: EntityAdAllocationUpdate;
};


export type MutationCreateEntityAdAllocationArgs = {
  entityAdAllocationInput: EntityAdAllocationInput;
};


export type MutationCreateFactArgs = {
  createFactInput: CreateFactInput;
};


export type MutationUpdateFactArgs = {
  updateFactInput: UpdateFactInput;
};


export type MutationCreateFactsArgs = {
  createFactsInput: CreateFactsInput;
};


export type MutationDeleteFactArgs = {
  factId: Scalars['Float'];
};


export type MutationDeleteFactsArgs = {
  deleteFactsInput: DeleteFactsInput;
};


export type MutationResetMatchArgs = {
  matchId: Scalars['Float'];
};


export type MutationDeleteFileArgs = {
  id: Scalars['Float'];
};


export type MutationToggleStartingArgs = {
  starting: Scalars['Boolean'];
  playerId: Scalars['Float'];
  teamId: Scalars['Float'];
  matchId: Scalars['Float'];
};


export type MutationSetCaptainArgs = {
  playerId: Scalars['Float'];
  teamId: Scalars['Float'];
  matchId: Scalars['Float'];
};


export type MutationCreateMatchArgs = {
  createMatchInput: CreateMatchInput;
};


export type MutationUpdateMatchArgs = {
  updateMatchInput: UpdateMatchInput;
};


export type MutationDeleteMatchArgs = {
  id: Scalars['Float'];
};


export type MutationRestoreMatchArgs = {
  id: Scalars['Float'];
};


export type MutationAddPlayerToLineupArgs = {
  teamId: Scalars['Float'];
  playerId: Scalars['Float'];
  id: Scalars['Float'];
};


export type MutationRemovePlayerFromLineupArgs = {
  teamId: Scalars['Float'];
  playerId: Scalars['Float'];
  id: Scalars['Float'];
};


export type MutationCreateOrganizationAdapterArgs = {
  createOrganizationAdapterInput: CreateOrganizationAdapterInput;
};


export type MutationDeleteOrganizationAdapterArgs = {
  id: Scalars['Float'];
};


export type MutationCreateOrganizationArgs = {
  createOrganizationInput: CreateOrganizationInput;
};


export type MutationUpdateOrganizationArgs = {
  updateOrganizationInput: UpdateOrganizationInput;
};


export type MutationToggleManualPaymentForOrganizationArgs = {
  organizationId: Scalars['Float'];
};


export type MutationToggleBlockOrganizationArgs = {
  organizationId: Scalars['Float'];
};


export type MutationCreateOverlayArgs = {
  createOverlayInput: CreateOverlayInput;
};


export type MutationUpdateOverlayArgs = {
  updateOverlayInput: UpdateOverlayInput;
};


export type MutationDeleteOverlayArgs = {
  id: Scalars['Float'];
};


export type MutationCreateManualGraphicsCommandArgs = {
  manualGraphicsUpdate: ManualGraphicsUpdate;
};


export type MutationPasswordResetArgs = {
  email: Scalars['String'];
};


export type MutationUpdatePasswordArgs = {
  updatePassword: UpdatePasswordInput;
};


export type MutationUpdatePasswordWithCurrentArgs = {
  newPassword: Scalars['String'];
  currentPassword: Scalars['String'];
};


export type MutationInviteArgs = {
  user: InviteUserInput;
};


export type MutationUpdatePermissionArgs = {
  role: Scalars['String'];
  userId: Scalars['Float'];
};


export type MutationTransferOwnershipArgs = {
  userId: Scalars['Float'];
};


export type MutationRevokeArgs = {
  userId: Scalars['Float'];
};


export type MutationCreatePlayerArgs = {
  createPlayerInput: CreatePlayerInput;
};


export type MutationJoinTeamArgs = {
  teamInput: JoinTeamInput;
  id: Scalars['Float'];
};


export type MutationUpdatePlayerArgs = {
  updatePlayerInput: UpdatePlayerInput;
};


export type MutationLeaveTeamArgs = {
  teamId: Scalars['Float'];
  id: Scalars['Float'];
};


export type MutationDeletePlayerArgs = {
  id: Scalars['Float'];
};


export type MutationRestorePlayerArgs = {
  id: Scalars['Float'];
};


export type MutationRegisterArgs = {
  registerInput: RegisterInput;
};


export type MutationConfirmEmailArgs = {
  token: Scalars['String'];
};


export type MutationCreateOrUpdateSubscriptionArgs = {
  ccLast4?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  plan: Scalars['String'];
};


export type MutationUpdateCardArgs = {
  ccLast4: Scalars['String'];
  source: Scalars['String'];
};


export type MutationCancelSubscriptionArgs = {
  reason: Scalars['String'];
};


export type MutationCreateTeamArgs = {
  createTeamInput: CreateTeamInput;
};


export type MutationUpdateTeamArgs = {
  clubOverride?: Maybe<Scalars['Boolean']>;
  updateTeamInput: UpdateTeamInput;
};


export type MutationDeleteTeamArgs = {
  id: Scalars['Float'];
};


export type MutationRestoreTeamArgs = {
  id: Scalars['Float'];
};


export type MutationUpdateUserArgs = {
  userInput: UpdateUserInput;
};


export type MutationChangePasswordArgs = {
  updatePassword: UpdateUserPasswordInput;
};


export type MutationToggleBlockUserArgs = {
  userId: Scalars['Float'];
};


export type MutationToggleAdminUserArgs = {
  userId: Scalars['Float'];
};


export type MutationCreateVenueArgs = {
  createVenueInput: CreateVenueInput;
};


export type MutationUpdateVenueArgs = {
  updateVenueInput: UpdateVenueInput;
};


export type MutationDeleteVenueArgs = {
  id: Scalars['Float'];
};


export type MutationRestoreVenueArgs = {
  id: Scalars['Float'];
};

export type Organization = {
   __typename?: 'Organization';
  id: Scalars['Float'];
  name: Scalars['String'];
  stripeCustomerId?: Maybe<Scalars['String']>;
  stripePlanId?: Maybe<Scalars['String']>;
  stripeCardLast4?: Maybe<Scalars['String']>;
  planQuantity?: Maybe<Scalars['Float']>;
  currentUsage: Scalars['Float'];
  manualPayment: Scalars['Boolean'];
  blocked: Scalars['Boolean'];
  logo?: Maybe<File>;
  default: Scalars['Boolean'];
};

export type OrganizationAdapter = {
   __typename?: 'OrganizationAdapter';
  id: Scalars['Float'];
  organizationId: Scalars['Float'];
  organization: Organization;
  providerCompetitionId: Scalars['Float'];
  providerName: Scalars['String'];
};

export type Overlay = {
   __typename?: 'Overlay';
  id: Scalars['Float'];
  name: Scalars['String'];
  matchId: Scalars['Float'];
  match: Match;
  encodingDelay: Scalars['Float'];
  autoMode: Scalars['Boolean'];
  testMode: Scalars['Boolean'];
  resolution: Scalars['Float'];
  showWatermarks: Scalars['Boolean'];
  background: Scalars['String'];
  backgroundColor?: Maybe<Scalars['String']>;
  enableAds: Scalars['Boolean'];
  key: Scalars['String'];
  manualGraphicState: Scalars['JSON'];
};

export type PeriodStats = {
   __typename?: 'PeriodStats';
  period: Scalars['String'];
  home: SportStats;
  away: SportStats;
  players: Array<PlayerStats>;
};

export enum PeriodStatus {
  live = 'live',
  break = 'break'
}

export enum PeriodType {
  regular = 'regular',
  overtime = 'overtime'
}

export type Plan = {
   __typename?: 'Plan';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type Player = {
   __typename?: 'Player';
  id: Scalars['Float'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  gfxFirstName?: Maybe<Scalars['String']>;
  gfxLastName?: Maybe<Scalars['String']>;
  playsFor?: Maybe<Array<TeamWithPlayerPhoto>>;
  countTeams: Scalars['Float'];
  baseId?: Maybe<Scalars['Float']>;
  baseEntity?: Maybe<PlayerBase>;
  archived: Scalars['Boolean'];
};

export type PlayerBase = {
   __typename?: 'PlayerBase';
  id: Scalars['Float'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  providerId: Scalars['Float'];
  providerName: Scalars['String'];
};

export type PlayerInput = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  gfxFirstName?: Maybe<Scalars['String']>;
  gfxLastName?: Maybe<Scalars['String']>;
  teams?: Maybe<Array<PlayerTeamsInput>>;
};

export type PlayerStats = {
   __typename?: 'PlayerStats';
  playerId: Scalars['Float'];
  stats: SportStats;
};

export type PlayerTeamsInput = {
  teamId: Scalars['Float'];
  photo?: Maybe<Scalars['Upload']>;
  photoId?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['String']>;
  positionType?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  defaultStarter?: Maybe<Scalars['Boolean']>;
  delete?: Maybe<Scalars['Boolean']>;
};

export type Query = {
   __typename?: 'Query';
  adFile: AdFile;
  adFiles: Array<AdFile>;
  adSet: AdSet;
  adSets: Array<AdSet>;
  verifyToken: VerifyOutput;
  invoices?: Maybe<Array<Invoice>>;
  clubsAndTeams: Array<ClubOrTeam>;
  club: Club;
  clubs: Array<Club>;
  competitionBases: Array<CompetitionBase>;
  searchCompetitions: Array<Competition>;
  competitions: Array<Competition>;
  competition: Competition;
  adAllocations: Array<EntityAdAllocation>;
  adAllocation: Array<EntityAdAllocation>;
  fact: Fact;
  facts: Array<Fact>;
  grade: Array<Grade>;
  grades: Array<Grade>;
  heartbeat: HeartBeat;
  matches: Matches;
  match: Match;
  matchSummary: MatchSummary;
  me: Me;
  searchOrganizationAdapters: Array<OrganizationAdapter>;
  searchOrganizations: Array<Organization>;
  currentOrganization: Organization;
  overlay: Overlay;
  overlays: Array<Overlay>;
  permission: UserOrganization;
  mePermission: Array<UserOrganization>;
  permissions: Array<UserOrganization>;
  plans: Array<Plan>;
  searchPlayers: Array<Player>;
  searchTeamPlayers: Array<Player>;
  players: Array<Player>;
  playersForTeam: Array<Player>;
  player: Player;
  serverTime: ServerTime;
  sports: Array<Sport>;
  sport: Sport;
  searchTeams: Array<Team>;
  teams: Array<Team>;
  team: Team;
  themes: Array<Theme>;
  theme: Theme;
  searchUsers: Array<User>;
  venues: Array<Venue>;
  venue: Venue;
};


export type QueryAdFileArgs = {
  id: Scalars['Float'];
};


export type QueryAdSetArgs = {
  id: Scalars['Float'];
};


export type QueryAdSetsArgs = {
  options?: Maybe<IQueryOptions>;
};


export type QueryVerifyTokenArgs = {
  accessToken: Scalars['String'];
};


export type QueryClubsAndTeamsArgs = {
  options?: Maybe<IQueryOptions>;
};


export type QueryClubArgs = {
  id: Scalars['Float'];
};


export type QueryCompetitionBasesArgs = {
  options?: Maybe<IQueryOptions>;
};


export type QuerySearchCompetitionsArgs = {
  query: Scalars['String'];
};


export type QueryCompetitionsArgs = {
  options?: Maybe<IQueryOptions>;
};


export type QueryCompetitionArgs = {
  id: Scalars['Float'];
};


export type QueryAdAllocationArgs = {
  adAllocationArgs: AdAllocationArgs;
};


export type QueryFactArgs = {
  factId: Scalars['Float'];
};


export type QueryFactsArgs = {
  matchId: Scalars['Float'];
};


export type QueryGradeArgs = {
  id: Scalars['Float'];
};


export type QueryHeartbeatArgs = {
  key: Scalars['String'];
};


export type QueryMatchesArgs = {
  finishedStatus?: Maybe<Array<EFinishedStatus>>;
  options?: Maybe<IQueryOptions>;
  query?: Maybe<Scalars['String']>;
  teamId?: Maybe<Scalars['Float']>;
  sportId?: Maybe<Scalars['Float']>;
  competitionId?: Maybe<Scalars['Float']>;
};


export type QueryMatchArgs = {
  id: Scalars['Float'];
};


export type QueryMatchSummaryArgs = {
  matchId: Scalars['Float'];
};


export type QuerySearchOrganizationAdaptersArgs = {
  query: Scalars['String'];
};


export type QuerySearchOrganizationsArgs = {
  query: Scalars['String'];
};


export type QueryOverlayArgs = {
  id?: Maybe<Scalars['Float']>;
  key?: Maybe<Scalars['String']>;
};


export type QueryOverlaysArgs = {
  matchId: Scalars['Float'];
};


export type QueryPermissionArgs = {
  userId: Scalars['Float'];
};


export type QuerySearchPlayersArgs = {
  options?: Maybe<IQueryOptions>;
  searchFromStart?: Maybe<Scalars['Boolean']>;
  searchOnFields: Array<Scalars['String']>;
  searchStr: Scalars['String'];
};


export type QuerySearchTeamPlayersArgs = {
  query: Scalars['String'];
  teamId: Scalars['Float'];
};


export type QueryPlayersArgs = {
  options?: Maybe<IQueryOptions>;
};


export type QueryPlayersForTeamArgs = {
  teamId: Scalars['Float'];
};


export type QueryPlayerArgs = {
  id: Scalars['Float'];
};


export type QuerySportArgs = {
  id: Scalars['Float'];
};


export type QuerySearchTeamsArgs = {
  options?: Maybe<IQueryOptions>;
  query: Scalars['String'];
};


export type QueryTeamsArgs = {
  options?: Maybe<IQueryOptions>;
  competitionId?: Maybe<Scalars['Float']>;
};


export type QueryTeamArgs = {
  clubOverride?: Maybe<Scalars['Boolean']>;
  id: Scalars['Float'];
};


export type QueryThemesArgs = {
  sportId?: Maybe<Scalars['Float']>;
};


export type QueryThemeArgs = {
  id: Scalars['Float'];
};


export type QuerySearchUsersArgs = {
  query: Scalars['String'];
};


export type QueryVenuesArgs = {
  options?: Maybe<IQueryOptions>;
};


export type QueryVenueArgs = {
  id: Scalars['Float'];
};

export type RegisteredOrganization = {
   __typename?: 'RegisteredOrganization';
  id: Scalars['Float'];
  name: Scalars['String'];
};

export type RegisteredUser = {
   __typename?: 'RegisteredUser';
  id: Scalars['Float'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
};

export type RegisterInput = {
  user: CreateUserInput;
  organization: CreateOrganizationInput;
};

export type RegisterOutput = {
   __typename?: 'RegisterOutput';
  user: RegisteredUser;
  organization: RegisteredOrganization;
};

export type RugbyLeagueStats = {
   __typename?: 'RugbyLeagueStats';
  sport: Scalars['String'];
  points: Scalars['Float'];
  tries: Scalars['Float'];
  conversions: Scalars['Float'];
  missedConversions: Scalars['Float'];
  penaltyGoals: Scalars['Float'];
  dropGoals: Scalars['Float'];
};

export type RugbyUnionStats = {
   __typename?: 'RugbyUnionStats';
  sport: Scalars['String'];
  points: Scalars['Float'];
  tries: Scalars['Float'];
  tryAssists: Scalars['Float'];
  conversions: Scalars['Float'];
  conversionsMissed: Scalars['Float'];
  penaltyGoals: Scalars['Float'];
  penaltyGoalsMissed: Scalars['Float'];
  penaltyTries: Scalars['Float'];
  dropGoals: Scalars['Float'];
  dropGoalsMissed: Scalars['Float'];
  redCards: Scalars['Float'];
  yellowCards: Scalars['Float'];
  penaltiesConceded: Scalars['Float'];
  turnoversConceded: Scalars['Float'];
  scrums: Scalars['Float'];
  scrumsConceded: Scalars['Float'];
  lineouts: Scalars['Float'];
  lineoutsConceded: Scalars['Float'];
  rucks: Scalars['Float'];
  rucksConceded: Scalars['Float'];
  restarts: Scalars['Float'];
  freeKicks: Scalars['Float'];
  kickCompGoals: Scalars['Float'];
  kickCompGoalsMissed: Scalars['Float'];
  kicks: Scalars['Float'];
  cleanBreaks: Scalars['Float'];
  defenderBeatens: Scalars['Float'];
  substitutions: Scalars['Float'];
  possession: Scalars['Float'];
};

export type Score = {
   __typename?: 'Score';
  home: Scalars['Float'];
  away: Scalars['Float'];
};

export type ServerTime = {
   __typename?: 'ServerTime';
  date: Scalars['DateTime'];
};

export type ShootoutResults = {
   __typename?: 'ShootoutResults';
  home: Array<Scalars['Float']>;
  away: Array<Scalars['Float']>;
};

export type Sport = {
   __typename?: 'Sport';
  id: Scalars['Float'];
  name: Scalars['String'];
};

export type SportStats = FootballStats | RugbyLeagueStats | RugbyUnionStats;

export type Subscription = {
   __typename?: 'Subscription';
  matchesSubscription: MatchesSubscriptionUpdates;
  matchSubscription: MatchUpdate;
  matchFeed: MatchFeedBroadcast;
  updatedOverlay: Overlay;
};


export type SubscriptionMatchesSubscriptionArgs = {
  matchesSubscriptionArgs: MatchesSubscriptionArgs;
};


export type SubscriptionMatchSubscriptionArgs = {
  matchSubscriptionArgs: MatchSubscriptionArgs;
};


export type SubscriptionMatchFeedArgs = {
  id: Scalars['Float'];
};


export type SubscriptionUpdatedOverlayArgs = {
  id: Scalars['Float'];
};

export type Team = {
   __typename?: 'Team';
  id: Scalars['Float'];
  name: Scalars['String'];
  gfxName?: Maybe<Scalars['String']>;
  gfxFullName?: Maybe<Scalars['String']>;
  abbreviation?: Maybe<Scalars['String']>;
  defaultVenueId?: Maybe<Scalars['Float']>;
  defaultVenue?: Maybe<Venue>;
  sportId: Scalars['Float'];
  sport: Sport;
  competitions: Array<Competition>;
  primaryBackgroundColor?: Maybe<Scalars['String']>;
  primaryTextColor?: Maybe<Scalars['String']>;
  secondaryBackgroundColor?: Maybe<Scalars['String']>;
  secondaryTextColor?: Maybe<Scalars['String']>;
  organizationId: Scalars['Float'];
  organization: Organization;
  logo?: Maybe<File>;
  players?: Maybe<Array<Player>>;
  adAllocation?: Maybe<EntityAdAllocation>;
  baseEntity?: Maybe<TeamBase>;
  countPlayers: Scalars['Float'];
  countMatches: Scalars['Float'];
  archived: Scalars['Boolean'];
  age: Age;
  gender: Gender;
  grade: Grade;
  club?: Maybe<Club>;
};

export type TeamAllocationConfig = {
   __typename?: 'TeamAllocationConfig';
  enabled: Scalars['Boolean'];
  percentage: Scalars['Float'];
};

export type TeamAllocationConfigInput = {
  enabled: Scalars['Boolean'];
  percentage: Scalars['Float'];
};

export type TeamBase = {
   __typename?: 'TeamBase';
  id: Scalars['Float'];
  name: Scalars['String'];
  gfxName: Scalars['String'];
  gfxFullName: Scalars['String'];
  abbreviation: Scalars['String'];
  sport: Sport;
};

export type TeamCompetitionsInput = {
  competitionId: Scalars['Float'];
  delete?: Maybe<Scalars['Boolean']>;
};

export type TeamWithPlayerPhoto = {
   __typename?: 'TeamWithPlayerPhoto';
  team: Team;
  photo?: Maybe<File>;
  position?: Maybe<Scalars['String']>;
  positionType?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  defaultStarter: Scalars['Boolean'];
};

export type Theme = {
   __typename?: 'Theme';
  id: Scalars['Float'];
  name: Scalars['String'];
  sportId: Scalars['Float'];
  sportName: Scalars['String'];
  usedBy?: Maybe<Array<Competition>>;
  sportDefault?: Maybe<Scalars['Boolean']>;
};

export type UpdateAdFileInput = {
  image: Scalars['Upload'];
  id: Scalars['Float'];
};

export type UpdateAdSetInput = {
  id: Scalars['Float'];
  name: Scalars['String'];
  teamId?: Maybe<Scalars['Float']>;
};

export type UpdateClubInput = {
  id: Scalars['Float'];
  name?: Maybe<Scalars['String']>;
  gfxName?: Maybe<Scalars['String']>;
  gfxFullName?: Maybe<Scalars['String']>;
  abbreviation?: Maybe<Scalars['String']>;
  defaultVenueId?: Maybe<Scalars['Float']>;
  primaryBackgroundColor?: Maybe<Scalars['String']>;
  primaryTextColor?: Maybe<Scalars['String']>;
  secondaryBackgroundColor?: Maybe<Scalars['String']>;
  secondaryTextColor?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['Upload']>;
};

export type UpdateCompetitionAdminInput = {
  id: Scalars['Float'];
  baseId?: Maybe<Scalars['Float']>;
};

export type UpdateCompetitionInput = {
  id: Scalars['Float'];
  name?: Maybe<Scalars['String']>;
  gfxName?: Maybe<Scalars['String']>;
  sportId?: Maybe<Scalars['Float']>;
  watermarkId?: Maybe<Scalars['Float']>;
  watermark?: Maybe<Scalars['Upload']>;
  secondaryWatermarkId?: Maybe<Scalars['Float']>;
  secondaryWatermark?: Maybe<Scalars['Upload']>;
  logoId?: Maybe<Scalars['Float']>;
  logo?: Maybe<Scalars['Upload']>;
  matchConfig?: Maybe<Scalars['JSON']>;
  overlayConfig?: Maybe<Scalars['JSON']>;
  themeId?: Maybe<Scalars['Float']>;
  age?: Maybe<Age>;
  gender?: Maybe<Gender>;
  gradeId?: Maybe<Scalars['Float']>;
};

export type UpdateEntityAdSetAllocation = {
  id: Scalars['Float'];
  percentage: Scalars['Float'];
  events: Array<Scalars['String']>;
};

export type UpdateFactInput = {
  factId: Scalars['Float'];
  name: FactName;
  teamId?: Maybe<Scalars['Float']>;
  playerId?: Maybe<Scalars['Float']>;
  clockMs?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['String']>;
  updated: Scalars['DateTime'];
  minute?: Maybe<Scalars['Float']>;
  date?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['JSON']>;
};

export type UpdateFileInput = {
  url: Scalars['String'];
  entityId: Scalars['Float'];
  entityType: FileEntityType;
};

export type UpdateMatchInput = {
  id: Scalars['Float'];
  name?: Maybe<Scalars['String']>;
  venueId?: Maybe<Scalars['Float']>;
  date?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  homeTeamId?: Maybe<Scalars['Float']>;
  awayTeamId?: Maybe<Scalars['Float']>;
  config?: Maybe<Scalars['JSON']>;
};

export type UpdateOrganizationInput = {
  id: Scalars['Float'];
  name: Scalars['String'];
  default?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<Scalars['Upload']>;
};

export type UpdateOverlayInput = {
  id: Scalars['Float'];
  name?: Maybe<Scalars['String']>;
  encodingDelay?: Maybe<Scalars['Float']>;
  autoMode?: Maybe<Scalars['Boolean']>;
  resolution?: Maybe<Scalars['Float']>;
  testMode?: Maybe<Scalars['Boolean']>;
  showWatermarks?: Maybe<Scalars['Boolean']>;
  enableAds?: Maybe<Scalars['Boolean']>;
  background?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
};

export type UpdatePasswordInput = {
  token: Scalars['String'];
  password: Scalars['String'];
};

export type UpdatePlayerInput = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  gfxFirstName?: Maybe<Scalars['String']>;
  gfxLastName?: Maybe<Scalars['String']>;
  teams?: Maybe<Array<PlayerTeamsInput>>;
  id: Scalars['Float'];
};

export type UpdateTeamInput = {
  id: Scalars['Float'];
  name?: Maybe<Scalars['String']>;
  gfxName?: Maybe<Scalars['String']>;
  gfxFullName?: Maybe<Scalars['String']>;
  abbreviation?: Maybe<Scalars['String']>;
  defaultVenueId?: Maybe<Scalars['Float']>;
  newDefaultVenue?: Maybe<CreateVenueInput>;
  primaryBackgroundColor?: Maybe<Scalars['String']>;
  primaryTextColor?: Maybe<Scalars['String']>;
  secondaryBackgroundColor?: Maybe<Scalars['String']>;
  secondaryTextColor?: Maybe<Scalars['String']>;
  logoId?: Maybe<Scalars['Float']>;
  logo?: Maybe<Scalars['Upload']>;
  competitions?: Maybe<Array<TeamCompetitionsInput>>;
  age?: Maybe<Age>;
  gender?: Maybe<Gender>;
  gradeId?: Maybe<Scalars['Float']>;
  clubId?: Maybe<Scalars['Float']>;
};

export type UpdateUserInput = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['Upload']>;
};

export type UpdateUserPasswordInput = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};

export type UpdateVenueInput = {
  name: Scalars['String'];
  gfxName?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
};


export type User = {
   __typename?: 'User';
  id: Scalars['Float'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  photo?: Maybe<File>;
  organizations: Array<Organization>;
  blocked: Scalars['Boolean'];
  admin: Scalars['Boolean'];
};

export type UserOrganization = {
   __typename?: 'UserOrganization';
  id: Scalars['Float'];
  userId: Scalars['Float'];
  user: User;
  organizationId: Scalars['Float'];
  organization: Organization;
  default: Scalars['Boolean'];
  role: Scalars['String'];
};

export type Venue = {
   __typename?: 'Venue';
  id: Scalars['Float'];
  name: Scalars['String'];
  gfxName?: Maybe<Scalars['String']>;
  organizationId: Scalars['Float'];
  organization: Organization;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  baseEntity?: Maybe<VenueBase>;
  countDefaultVenue: Scalars['Float'];
  countMatches: Scalars['Float'];
  archived: Scalars['Boolean'];
};

export type VenueBase = {
   __typename?: 'VenueBase';
  id: Scalars['Float'];
  name: Scalars['String'];
};

export type VerifyOutput = {
   __typename?: 'VerifyOutput';
  valid: Scalars['Boolean'];
  userId?: Maybe<Scalars['Float']>;
  adminId?: Maybe<Scalars['Float']>;
};

export type ManualGraphicsUpdateMutationVariables = {
  manualGraphicsUpdate: ManualGraphicsUpdate;
};


export type ManualGraphicsUpdateMutation = { __typename?: 'Mutation', createManualGraphicsCommand: { __typename?: 'Overlay', id: number, manualGraphicState: any } };

export type CreateEntityAdAllocationMutationVariables = {
  entityAdAllocationInput: EntityAdAllocationInput;
};


export type CreateEntityAdAllocationMutation = { __typename?: 'Mutation', createEntityAdAllocation: { __typename?: 'EntityAdAllocation', entityId: number, entityType: AdAllocationEntityType, id: number } };

export type AdAllocationQueryVariables = {
  adAllocationArgs: AdAllocationArgs;
};


export type AdAllocationQuery = { __typename?: 'Query', adAllocation: Array<{ __typename?: 'EntityAdAllocation', entityId: number, entityType: AdAllocationEntityType, id: number }> };

export type CompetitionNameOnlyQueryVariables = {};


export type CompetitionNameOnlyQuery = { __typename?: 'Query', competitions: Array<{ __typename?: 'Competition', id: number, name: string }> };

export type SportsNameOnlyQueryVariables = {};


export type SportsNameOnlyQuery = { __typename?: 'Query', sports: Array<{ __typename?: 'Sport', id: number, name: string }> };

export type TeamsNameOnlyQueryVariables = {};


export type TeamsNameOnlyQuery = { __typename?: 'Query', teams: Array<{ __typename?: 'Team', id: number, name: string }> };

export type VerifyTokenQueryVariables = {
  accessToken: Scalars['String'];
};


export type VerifyTokenQuery = { __typename?: 'Query', verifyToken: { __typename?: 'VerifyOutput', valid: boolean, userId?: Maybe<number>, adminId?: Maybe<number> } };

export type LogoutMutationVariables = {};


export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename?: 'LogoutOutput', success: boolean } };

export type LoginMutationVariables = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginOutput', accessToken: string, defaultOrganization?: Maybe<{ __typename?: 'Organization', id: number }> } };

export type ImpersonateMutationVariables = {
  id: Scalars['Float'];
};


export type ImpersonateMutation = { __typename?: 'Mutation', impersonate: { __typename?: 'ImpersonateOutput', accessToken: string, adminId: number, defaultOrganization?: Maybe<{ __typename?: 'Organization', id: number }> } };

export type UnimpersonateMutationVariables = {};


export type UnimpersonateMutation = { __typename?: 'Mutation', unimpersonate: { __typename?: 'ImpersonateOutput', accessToken: string, defaultOrganization?: Maybe<{ __typename?: 'Organization', id: number }> } };

export type AdSetFragment = { __typename?: 'AdSet', id: number, name: string, archived: boolean, adFiles: Array<{ __typename?: 'AdFile', id: number, adSetId: number, size: string, file?: Maybe<{ __typename?: 'File', id: number, url: string, entityId: number, entityType: FileEntityType }> }> };

export type CompetitionWithTeamsAndAdAllocationFragment = { __typename?: 'Competition', id: number, name: string, gfxName?: Maybe<string>, matchConfig: any, overlayConfig: any, sportId: number, archived: boolean, teams: Array<{ __typename?: 'Team', id: number, name: string }>, sport: { __typename?: 'Sport', id: number, name: string }, watermark?: Maybe<{ __typename?: 'File', id: number, url: string }>, secondaryWatermark?: Maybe<{ __typename?: 'File', id: number, url: string }>, logo?: Maybe<{ __typename?: 'File', id: number, url: string }>, adAllocation?: Maybe<(
    { __typename?: 'EntityAdAllocation' }
    & CompetitionAdAllocationFragment
  )> };

export type CompetitionFragment = { __typename?: 'Competition', id: number, name: string, gfxName?: Maybe<string>, countMatches: number, countTeams: number, archived: boolean, age: Age, gender: Gender, sportId: number, matchConfig: any, overlayConfig: any, themeId: number, grade: { __typename?: 'Grade', id: number, name: string }, watermark?: Maybe<{ __typename?: 'File', id: number, url: string }>, secondaryWatermark?: Maybe<{ __typename?: 'File', id: number, url: string }>, logo?: Maybe<{ __typename?: 'File', id: number, url: string }>, sport: { __typename?: 'Sport', id: number, name: string }, adAllocation?: Maybe<(
    { __typename?: 'EntityAdAllocation' }
    & CompetitionAdAllocationFragment
  )>, baseEntity?: Maybe<{ __typename?: 'CompetitionBase', id: number, name: string }>, theme: { __typename?: 'Theme', id: number, name: string, sportId: number, sportName: string } };

export type SmallOverlayFragment = { __typename?: 'Overlay', matchId: number, id: number, encodingDelay: number, autoMode: boolean, enableAds: boolean, resolution: number, showWatermarks: boolean, background: string, backgroundColor?: Maybe<string>, key: string };

export type TeamPlayerFragment = { __typename?: 'Player', id: number, firstName: string, lastName: string, playsFor?: Maybe<Array<(
    { __typename?: 'TeamWithPlayerPhoto' }
    & PlaysForFragment
  )>> };

export type MinSummaryFragment = { __typename?: 'MatchSummary', matchId: number, currentPeriod: string, clock: { __typename?: 'ClockInfo', clockRunning: boolean, clockInMs: number, clockChangeDate?: Maybe<any> }, periods: Array<{ __typename?: 'MatchPeriod', duration?: Maybe<number>, name: string, code: string, preOvertimeBreak?: Maybe<boolean>, status: PeriodStatus, type: PeriodType, pregame?: Maybe<boolean>, aboutToStart?: Maybe<boolean>, playersEntered?: Maybe<boolean>, shootout?: Maybe<boolean>, finished?: Maybe<any>, number: number, started?: Maybe<any>, matchFinished?: Maybe<boolean> }>, matchStats: { __typename?: 'MatchStats', shootoutResults?: Maybe<Array<{ __typename?: 'ShootoutResults', home: Array<number>, away: Array<number> }>>, score: { __typename?: 'Score', home: number, away: number } } };

export type SummaryFragment = { __typename?: 'MatchSummary', matchId: number, currentPeriod: string, clock: { __typename?: 'ClockInfo', clockRunning: boolean, clockInMs: number, clockChangeDate?: Maybe<any> }, periods: Array<{ __typename?: 'MatchPeriod', duration?: Maybe<number>, name: string, code: string, preOvertimeBreak?: Maybe<boolean>, shortName: string, status: PeriodStatus, type: PeriodType, pregame?: Maybe<boolean>, aboutToStart?: Maybe<boolean>, playersEntered?: Maybe<boolean>, started?: Maybe<any>, number: number, finished?: Maybe<any>, shootout?: Maybe<boolean>, matchFinished?: Maybe<boolean> }>, matchStats: { __typename?: 'MatchStats', home: (
      { __typename?: 'FootballStats' }
      & FootballStatsFragment
    ) | (
      { __typename?: 'RugbyLeagueStats' }
      & LeagueStatsFragment
    ) | (
      { __typename?: 'RugbyUnionStats' }
      & UnionStatsFragment
    ), away: (
      { __typename?: 'FootballStats' }
      & FootballStatsFragment
    ) | (
      { __typename?: 'RugbyLeagueStats' }
      & LeagueStatsFragment
    ) | (
      { __typename?: 'RugbyUnionStats' }
      & UnionStatsFragment
    ), players: Array<{ __typename?: 'PlayerStats', playerId: number, stats: (
        { __typename?: 'FootballStats' }
        & FootballStatsFragment
      ) | (
        { __typename?: 'RugbyLeagueStats' }
        & LeagueStatsFragment
      ) | (
        { __typename?: 'RugbyUnionStats' }
        & UnionStatsFragment
      ) }>, periods: Array<{ __typename?: 'PeriodStats', period: string, home: (
        { __typename?: 'FootballStats' }
        & FootballStatsFragment
      ) | (
        { __typename?: 'RugbyLeagueStats' }
        & LeagueStatsFragment
      ) | (
        { __typename?: 'RugbyUnionStats' }
        & UnionStatsFragment
      ), away: (
        { __typename?: 'FootballStats' }
        & FootballStatsFragment
      ) | (
        { __typename?: 'RugbyLeagueStats' }
        & LeagueStatsFragment
      ) | (
        { __typename?: 'RugbyUnionStats' }
        & UnionStatsFragment
      ), players: Array<{ __typename?: 'PlayerStats', playerId: number, stats: (
          { __typename?: 'FootballStats' }
          & FootballStatsFragment
        ) | (
          { __typename?: 'RugbyLeagueStats' }
          & LeagueStatsFragment
        ) | (
          { __typename?: 'RugbyUnionStats' }
          & UnionStatsFragment
        ) }> }>, score: { __typename?: 'Score', home: number, away: number }, shootoutResults?: Maybe<Array<{ __typename?: 'ShootoutResults', home: Array<number>, away: Array<number> }>> } };

export type TeamFragment = { __typename?: 'Team', id: number, name: string, gfxName?: Maybe<string>, gfxFullName?: Maybe<string>, abbreviation?: Maybe<string>, primaryBackgroundColor?: Maybe<string>, primaryTextColor?: Maybe<string>, secondaryBackgroundColor?: Maybe<string>, secondaryTextColor?: Maybe<string>, organizationId: number, defaultVenueId?: Maybe<number>, sport: { __typename?: 'Sport', id: number }, competitions: Array<{ __typename?: 'Competition', id: number, name: string }>, logo?: Maybe<{ __typename?: 'File', id: number, url: string, entityId: number, entityType: FileEntityType }>, adAllocation?: Maybe<(
    { __typename?: 'EntityAdAllocation' }
    & TeamAdAllocationFragment
  )> };

export type AddTeamsToClubMutationVariables = {
  id: Scalars['Float'];
  teams: Array<ClubTeamsInput>;
};


export type AddTeamsToClubMutation = { __typename?: 'Mutation', addTeamsToClub: { __typename?: 'Club', id: number, name: string, gfxName: string, gfxFullName: string, abbreviation: string, primaryBackgroundColor?: Maybe<string>, primaryTextColor?: Maybe<string>, secondaryBackgroundColor?: Maybe<string>, secondaryTextColor?: Maybe<string>, organization: { __typename?: 'Organization', id: number }, defaultVenue?: Maybe<{ __typename?: 'Venue', id: number }>, teams?: Maybe<Array<{ __typename?: 'Team', id: number, name: string, age: Age, gender: Gender, sport: { __typename?: 'Sport', id: number }, competitions: Array<{ __typename?: 'Competition', id: number, name: string }>, grade: { __typename?: 'Grade', id: number, name: string } }>>, logo?: Maybe<{ __typename?: 'File', id: number, url: string, entityId: number, entityType: FileEntityType }> } };

export type CreateAdSetMutationVariables = {
  createAdSetInput: CreateAdSetInput;
};


export type CreateAdSetMutation = { __typename?: 'Mutation', createAdSet: (
    { __typename?: 'AdSet' }
    & AdSetFragment
  ) };

export type CreateClubMutationVariables = {
  createClubInput: CreateClubInput;
};


export type CreateClubMutation = { __typename?: 'Mutation', createClub: { __typename?: 'Club', id: number, name: string, gfxName: string, gfxFullName: string, abbreviation: string, primaryBackgroundColor?: Maybe<string>, primaryTextColor?: Maybe<string>, secondaryBackgroundColor?: Maybe<string>, secondaryTextColor?: Maybe<string>, organization: { __typename?: 'Organization', id: number }, defaultVenue?: Maybe<{ __typename?: 'Venue', id: number }>, logo?: Maybe<{ __typename?: 'File', id: number, url: string, entityId: number, entityType: FileEntityType }> } };

export type CreateCompetitionMutationVariables = {
  createCompetitionInput: CreateCompetitionInput;
};


export type CreateCompetitionMutation = { __typename?: 'Mutation', createCompetition: (
    { __typename?: 'Competition' }
    & CompetitionFragment
  ) };

export type CreateAdFileMutationVariables = {
  createAdFileInput: CreateAdFileInput;
};


export type CreateAdFileMutation = { __typename?: 'Mutation', createAdFile: (
    { __typename?: 'AdFile' }
    & AdFileFragment
  ) };

export type CreateMatchMutationVariables = {
  createMatchInput: CreateMatchInput;
};


export type CreateMatchMutation = { __typename?: 'Mutation', createMatch: { __typename?: 'Match', id: number, name: string, competitionId: number, date: any, config: any, awayTeam: { __typename?: 'Team', id: number, name: string }, homeTeam: { __typename?: 'Team', id: number, name: string }, competition: { __typename?: 'Competition', id: number, name: string }, overlays: Array<{ __typename?: 'Overlay', id: number, matchId: number, encodingDelay: number, autoMode: boolean, resolution: number, showWatermarks: boolean, background: string, enableAds: boolean, key: string }> } };

export type CreatePlayerMutationVariables = {
  createPlayerInput: CreatePlayerInput;
};


export type CreatePlayerMutation = { __typename?: 'Mutation', createPlayer: (
    { __typename?: 'Player' }
    & TeamPlayerFragment
  ) };

export type CreateTeamMutationVariables = {
  createTeamInput: CreateTeamInput;
};


export type CreateTeamMutation = { __typename?: 'Mutation', createTeam: { __typename?: 'Team', id: number, name: string, gfxName?: Maybe<string>, gfxFullName?: Maybe<string>, abbreviation?: Maybe<string>, primaryBackgroundColor?: Maybe<string>, primaryTextColor?: Maybe<string>, secondaryBackgroundColor?: Maybe<string>, secondaryTextColor?: Maybe<string>, organizationId: number, defaultVenueId?: Maybe<number>, sport: { __typename?: 'Sport', id: number }, competitions: Array<{ __typename?: 'Competition', id: number, name: string }>, logo?: Maybe<{ __typename?: 'File', id: number, url: string, entityId: number, entityType: FileEntityType }>, adAllocation?: Maybe<(
      { __typename?: 'EntityAdAllocation' }
      & AdAllocationFragment
    )> } };

export type CreateVenueMutationVariables = {
  createVenueInput: CreateVenueInput;
};


export type CreateVenueMutation = { __typename?: 'Mutation', createVenue: { __typename?: 'Venue', id: number, name: string, lat?: Maybe<number>, lng?: Maybe<number>, city?: Maybe<string>, state?: Maybe<string>, country?: Maybe<string>, postcode?: Maybe<string>, address?: Maybe<string> } };

export type DeleteAdFileMutationVariables = {
  id: Scalars['Float'];
};


export type DeleteAdFileMutation = { __typename?: 'Mutation', deleteAdFile: boolean };

export type DeleteAdSetMutationVariables = {
  id: Scalars['Float'];
};


export type DeleteAdSetMutation = { __typename?: 'Mutation', deleteAdSet: boolean };

export type DeleteFileMutationVariables = {
  id: Scalars['Float'];
};


export type DeleteFileMutation = { __typename?: 'Mutation', deleteFile: boolean };

export type DeletePlayerMutationVariables = {
  id: Scalars['Float'];
};


export type DeletePlayerMutation = { __typename?: 'Mutation', deletePlayer: boolean };

export type LeaveTeamMutationVariables = {
  teamId: Scalars['Float'];
  id: Scalars['Float'];
};


export type LeaveTeamMutation = { __typename?: 'Mutation', leaveTeam: { __typename?: 'Player', id: number, firstName: string, lastName: string } };

export type UpdateClubMutationVariables = {
  updateClubInput: UpdateClubInput;
};


export type UpdateClubMutation = { __typename?: 'Mutation', updateClub: { __typename?: 'Club', id: number, name: string, archived: boolean, gfxName: string, gfxFullName: string, abbreviation: string, primaryBackgroundColor?: Maybe<string>, primaryTextColor?: Maybe<string>, secondaryBackgroundColor?: Maybe<string>, secondaryTextColor?: Maybe<string>, logo?: Maybe<{ __typename?: 'File', id: number, url: string }>, defaultVenue?: Maybe<{ __typename?: 'Venue', id: number, name: string }>, teams?: Maybe<Array<{ __typename?: 'Team', id: number, age: Age, gender: Gender, sport: { __typename?: 'Sport', id: number }, competitions: Array<{ __typename?: 'Competition', id: number, name: string }>, grade: { __typename?: 'Grade', id: number, name: string } }>> } };

export type UpdateCompetitionMutationVariables = {
  updateCompetitionInput: UpdateCompetitionInput;
};


export type UpdateCompetitionMutation = { __typename?: 'Mutation', updateCompetition: { __typename?: 'Competition', id: number, name: string, gfxName?: Maybe<string>, themeId: number, age: Age, gender: Gender, matchConfig: any, overlayConfig: any, sportId: number, grade: { __typename?: 'Grade', id: number, name: string }, theme: { __typename?: 'Theme', id: number, name: string, sportId: number, sportName: string }, watermark?: Maybe<{ __typename?: 'File', id: number, url: string }>, baseEntity?: Maybe<{ __typename?: 'CompetitionBase', id: number, name: string }>, secondaryWatermark?: Maybe<{ __typename?: 'File', id: number, url: string }>, logo?: Maybe<{ __typename?: 'File', id: number, url: string }>, sport: { __typename?: 'Sport', id: number, name: string }, adAllocation?: Maybe<(
      { __typename?: 'EntityAdAllocation' }
      & CompetitionAdAllocationFragment
    )> } };

export type UpdateAdFileMutationVariables = {
  updateAdFileInput: UpdateAdFileInput;
};


export type UpdateAdFileMutation = { __typename?: 'Mutation', updateAdFile: { __typename?: 'AdFile', id: number, adSetId: number, size: string, file?: Maybe<{ __typename?: 'File', id: number, url: string, entityId: number, entityType: FileEntityType }>, adSet: { __typename?: 'AdSet', id: number, name: string, organizationId: number, teamId?: Maybe<number> } } };

export type UpdateMatchMutationVariables = {
  updateMatchInput: UpdateMatchInput;
};


export type UpdateMatchMutation = { __typename?: 'Mutation', updateMatch: { __typename?: 'Match', id: number, name: string, competitionId: number, date: any, config: any, sportName: string, awayTeam: { __typename?: 'Team', id: number, name: string }, homeTeam: { __typename?: 'Team', id: number, name: string }, competition: { __typename?: 'Competition', id: number, name: string }, baseEntity?: Maybe<{ __typename?: 'MatchBase', id: number, providerId: number, providerName: string }>, overlays: Array<{ __typename?: 'Overlay', id: number, matchId: number, encodingDelay: number, autoMode: boolean, resolution: number, showWatermarks: boolean, background: string, enableAds: boolean, key: string }>, summary: { __typename?: 'MatchSummary', matchId: number, currentPeriod: string } } };

export type UpdatePlayerMutationVariables = {
  updatePlayerInput: UpdatePlayerInput;
};


export type UpdatePlayerMutation = { __typename?: 'Mutation', updatePlayer: { __typename?: 'Player', id: number, firstName: string, lastName: string, gfxFirstName?: Maybe<string>, gfxLastName?: Maybe<string>, playsFor?: Maybe<Array<(
      { __typename?: 'TeamWithPlayerPhoto' }
      & PlaysForFragment
    )>> } };

export type UpdateVenueMutationVariables = {
  updateVenueInput: UpdateVenueInput;
};


export type UpdateVenueMutation = { __typename?: 'Mutation', updateVenue: { __typename?: 'Venue', id: number, name: string, gfxName?: Maybe<string>, lat?: Maybe<number>, lng?: Maybe<number>, city?: Maybe<string>, state?: Maybe<string>, country?: Maybe<string>, postcode?: Maybe<string>, address?: Maybe<string>, baseEntity?: Maybe<{ __typename?: 'VenueBase', id: number, name: string }> } };

export type AdAllocationWithEntityQueryVariables = {
  adAllocationArgs: AdAllocationArgs;
};


export type AdAllocationWithEntityQuery = { __typename?: 'Query', adAllocation: Array<(
    { __typename?: 'EntityAdAllocation', id: number, entityId: number, entityType: AdAllocationEntityType, entity: { __typename?: 'Team', name: string, id: number, logo?: Maybe<{ __typename?: 'File', id: number, url: string }>, sport: { __typename?: 'Sport', id: number, name: string } } | { __typename?: 'Competition', name: string, id: number, logo?: Maybe<{ __typename?: 'File', id: number, url: string }>, sport: { __typename?: 'Sport', id: number, name: string } } }
    & CompetitionAdAllocationFragment
  )> };

export type AdAllocationsQueryVariables = {};


export type AdAllocationsQuery = { __typename?: 'Query', adAllocations: Array<(
    { __typename?: 'EntityAdAllocation', id: number, entityId: number, entityType: AdAllocationEntityType, entity: { __typename?: 'Team', countMatches: number, countPlayers: number, archived: boolean, name: string, id: number, logo?: Maybe<{ __typename?: 'File', id: number, url: string }>, sport: { __typename?: 'Sport', id: number, name: string } } | { __typename?: 'Competition', name: string, id: number, countTeams: number, countMatches: number, archived: boolean, logo?: Maybe<{ __typename?: 'File', id: number, url: string }>, sport: { __typename?: 'Sport', id: number, name: string } } }
    & CompetitionAdAllocationFragment
  )> };

export type ClubsQueryVariables = {};


export type ClubsQuery = { __typename?: 'Query', clubs: Array<{ __typename?: 'Club', id: number, name: string }> };

export type ClubQueryVariables = {
  id: Scalars['Float'];
};


export type ClubQuery = { __typename?: 'Query', club: { __typename?: 'Club', id: number, name: string, archived: boolean, gfxName: string, gfxFullName: string, abbreviation: string, primaryBackgroundColor?: Maybe<string>, primaryTextColor?: Maybe<string>, secondaryBackgroundColor?: Maybe<string>, secondaryTextColor?: Maybe<string>, logo?: Maybe<{ __typename?: 'File', id: number, url: string }>, defaultVenue?: Maybe<{ __typename?: 'Venue', id: number, name: string }>, teams?: Maybe<Array<{ __typename?: 'Team', id: number, age: Age, gender: Gender, archived: boolean, countMatches: number, countPlayers: number, grade: { __typename?: 'Grade', id: number, name: string }, sport: { __typename?: 'Sport', id: number, name: string }, competitions: Array<{ __typename?: 'Competition', id: number, name: string, logo?: Maybe<{ __typename?: 'File', id: number, url: string }>, sport: { __typename?: 'Sport', id: number, name: string } }> }>> } };

export type ClubsAndTeamsQueryVariables = {
  options?: Maybe<IQueryOptions>;
};


export type ClubsAndTeamsQuery = { __typename?: 'Query', clubsAndTeams: Array<{ __typename?: 'Club', id: number, name: string, archived: boolean, logo?: Maybe<{ __typename?: 'File', id: number, url: string }>, teams?: Maybe<Array<{ __typename?: 'Team', id: number, age: Age, gender: Gender, archived: boolean, countMatches: number, countPlayers: number, grade: { __typename?: 'Grade', id: number, name: string }, sport: { __typename?: 'Sport', id: number, name: string }, competitions: Array<{ __typename?: 'Competition', id: number, name: string, logo?: Maybe<{ __typename?: 'File', id: number, url: string }>, sport: { __typename?: 'Sport', id: number, name: string } }> }>> } | { __typename?: 'Team', id: number, name: string, countMatches: number, countPlayers: number, archived: boolean, age: Age, gender: Gender, logo?: Maybe<{ __typename?: 'File', id: number, url: string }>, sport: { __typename?: 'Sport', id: number, name: string }, grade: { __typename?: 'Grade', id: number, name: string }, competitions: Array<{ __typename?: 'Competition', id: number, name: string, logo?: Maybe<{ __typename?: 'File', id: number, url: string }>, sport: { __typename?: 'Sport', id: number, name: string } }> }> };

export type CompetitionQueryVariables = {
  id: Scalars['Float'];
};


export type CompetitionQuery = { __typename?: 'Query', competition: (
    { __typename?: 'Competition' }
    & CompetitionFragment
  ) };

export type FullCompetitionFragment = { __typename?: 'Competition', id: number, name: string, gfxName?: Maybe<string>, countMatches: number, countTeams: number, themeId: number, archived: boolean, sportId: number, matchConfig: any, overlayConfig: any, theme: { __typename?: 'Theme', id: number, name: string, sportId: number, sportName: string }, teams: Array<{ __typename?: 'Team', id: number, name: string, defaultVenueId?: Maybe<number> }>, watermark?: Maybe<{ __typename?: 'File', id: number, url: string }>, secondaryWatermark?: Maybe<{ __typename?: 'File', id: number, url: string }>, logo?: Maybe<{ __typename?: 'File', id: number, url: string }>, sport: { __typename?: 'Sport', id: number, name: string }, adAllocation?: Maybe<(
    { __typename?: 'EntityAdAllocation' }
    & CompetitionAdAllocationFragment
  )> };

export type CompetitionsQueryVariables = {
  options?: Maybe<IQueryOptions>;
};


export type CompetitionsQuery = { __typename?: 'Query', competitions: Array<(
    { __typename?: 'Competition' }
    & FullCompetitionFragment
  )> };

export type FactsQueryVariables = {
  matchId: Scalars['Float'];
};


export type FactsQuery = { __typename?: 'Query', facts: Array<(
    { __typename?: 'Fact', player?: Maybe<{ __typename?: 'Player', id: number, firstName: string, lastName: string, playsFor?: Maybe<Array<(
        { __typename?: 'TeamWithPlayerPhoto' }
        & PlaysForFragment
      )>> }> }
    & FactFragment
  )> };

export type GradesQueryVariables = {};


export type GradesQuery = { __typename?: 'Query', grades: Array<{ __typename?: 'Grade', id: number, name: string }> };

export type MatchWithOverlaysFragment = { __typename?: 'Match', id: number, name: string, organizationId: number, awayTeamId: number, homeTeamId: number, venueId: number, competitionId: number, description?: Maybe<string>, date: any, config: any, sportName: string, archived: boolean, hasFacts: boolean, competition: { __typename?: 'Competition', themeId: number, sport: { __typename?: 'Sport', id: number, name: string } }, summary: { __typename?: 'MatchSummary', matchId: number, currentPeriod: string, clock: { __typename?: 'ClockInfo', clockRunning: boolean, clockInMs: number, clockChangeDate?: Maybe<any> }, matchStats: { __typename?: 'MatchStats', score: { __typename?: 'Score', home: number, away: number } } }, overlays: Array<{ __typename?: 'Overlay', id: number, matchId: number, encodingDelay: number, autoMode: boolean, resolution: number, showWatermarks: boolean, background: string, backgroundColor?: Maybe<string>, enableAds: boolean, name: string, key: string, manualGraphicState: any }>, homeTeam: { __typename?: 'Team', id: number, name: string }, awayTeam: { __typename?: 'Team', id: number, name: string } };

export type MatchWithOverlaysQueryVariables = {
  id: Scalars['Float'];
};


export type MatchWithOverlaysQuery = { __typename?: 'Query', match: (
    { __typename?: 'Match' }
    & MatchWithOverlaysFragment
  ) };

export type MatchesQueryVariables = {
  finishedStatus?: Maybe<Array<EFinishedStatus>>;
  options?: Maybe<IQueryOptions>;
  query?: Maybe<Scalars['String']>;
  teamId?: Maybe<Scalars['Float']>;
  sportId?: Maybe<Scalars['Float']>;
  competitionId?: Maybe<Scalars['Float']>;
};


export type MatchesQuery = { __typename?: 'Query', matches: { __typename?: 'Matches', total: number, matches: Array<{ __typename?: 'Match', id: number, name: string, archived: boolean, sportName: string, liveStatus: PeriodStatus, competitionId: number, date: any, organizationId: number, finishedStatus: string, coverage?: Maybe<boolean>, hasFacts: boolean, config: any, score: { __typename?: 'Score', home: number, away: number }, awayTeam: { __typename?: 'Team', id: number, name: string, abbreviation?: Maybe<string>, logo?: Maybe<{ __typename?: 'File', id: number, url: string }> }, homeTeam: { __typename?: 'Team', id: number, name: string, abbreviation?: Maybe<string>, logo?: Maybe<{ __typename?: 'File', id: number, url: string }> }, competition: { __typename?: 'Competition', id: number, name: string, sport: { __typename?: 'Sport', id: number, name: string }, logo?: Maybe<{ __typename?: 'File', id: number, url: string }> }, baseEntity?: Maybe<{ __typename?: 'MatchBase', id: number, providerId: number, providerName: string }>, overlays: Array<{ __typename?: 'Overlay', id: number, matchId: number, name: string, encodingDelay: number, autoMode: boolean, testMode: boolean, resolution: number, showWatermarks: boolean, background: string, enableAds: boolean, key: string }>, summary: (
        { __typename?: 'MatchSummary' }
        & SummaryFragment
      ) }> } };

export type PlayerQueryVariables = {
  id: Scalars['Float'];
};


export type PlayerQuery = { __typename?: 'Query', player: { __typename?: 'Player', id: number, firstName: string, lastName: string, gfxFirstName?: Maybe<string>, gfxLastName?: Maybe<string>, countTeams: number, archived: boolean, playsFor?: Maybe<Array<{ __typename?: 'TeamWithPlayerPhoto', position?: Maybe<string>, positionType?: Maybe<string>, number?: Maybe<string>, defaultStarter: boolean, team: { __typename?: 'Team', id: number, name: string, abbreviation?: Maybe<string> }, photo?: Maybe<{ __typename?: 'File', id: number, url: string }> }>> } };

export type PlayersQueryVariables = {
  options?: Maybe<IQueryOptions>;
};


export type PlayersQuery = { __typename?: 'Query', players: Array<{ __typename?: 'Player', id: number, firstName: string, lastName: string, countTeams: number, archived: boolean, playsFor?: Maybe<Array<(
      { __typename?: 'TeamWithPlayerPhoto', team: { __typename?: 'Team', id: number, name: string, competitions: Array<{ __typename?: 'Competition', id: number, name: string, sport: { __typename?: 'Sport', id: number, name: string } }> } }
      & PlaysForFragment
    )>> }> };

export type PlayersForTeamQueryVariables = {
  teamId: Scalars['Float'];
};


export type PlayersForTeamQuery = { __typename?: 'Query', playersForTeam: Array<{ __typename?: 'Player', id: number, archived: boolean, countTeams: number, firstName: string, lastName: string, playsFor?: Maybe<Array<(
      { __typename?: 'TeamWithPlayerPhoto' }
      & PlaysForFragment
    )>> }> };

export type SportsQueryVariables = {};


export type SportsQuery = { __typename?: 'Query', sports: Array<{ __typename?: 'Sport', id: number, name: string }> };

export type MatchSummaryQueryVariables = {
  matchId: Scalars['Float'];
};


export type MatchSummaryQuery = { __typename?: 'Query', matchSummary: (
    { __typename?: 'MatchSummary' }
    & SummaryFragment
  ) };

export type TeamQueryVariables = {
  id: Scalars['Float'];
  clubOverride?: Maybe<Scalars['Boolean']>;
};


export type TeamQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: number, name: string, gfxName?: Maybe<string>, gfxFullName?: Maybe<string>, abbreviation?: Maybe<string>, primaryBackgroundColor?: Maybe<string>, primaryTextColor?: Maybe<string>, secondaryBackgroundColor?: Maybe<string>, secondaryTextColor?: Maybe<string>, defaultVenueId?: Maybe<number>, countMatches: number, countPlayers: number, archived: boolean, age: Age, gender: Gender, club?: Maybe<{ __typename?: 'Club', id: number }>, grade: { __typename?: 'Grade', id: number }, competitions: Array<{ __typename?: 'Competition', id: number, name: string }>, sport: { __typename?: 'Sport', id: number, name: string }, logo?: Maybe<{ __typename?: 'File', id: number, url: string }>, baseEntity?: Maybe<{ __typename?: 'TeamBase', id: number, name: string, gfxName: string, gfxFullName: string, abbreviation: string }> } };

export type TeamWithCompFragment = { __typename?: 'Team', id: number, name: string, defaultVenueId?: Maybe<number>, countMatches: number, countPlayers: number, archived: boolean, sport: { __typename?: 'Sport', id: number, name: string }, logo?: Maybe<{ __typename?: 'File', id: number, url: string }>, competitions: Array<{ __typename?: 'Competition', id: number, name: string, logo?: Maybe<{ __typename?: 'File', id: number, url: string }>, sport: { __typename?: 'Sport', id: number, name: string } }> };

export type TeamsWithCompQueryVariables = {
  competitionId?: Maybe<Scalars['Float']>;
  options?: Maybe<IQueryOptions>;
};


export type TeamsWithCompQuery = { __typename?: 'Query', teams: Array<(
    { __typename?: 'Team' }
    & TeamWithCompFragment
  )> };

export type TeamswithSportQueryVariables = {
  options?: Maybe<IQueryOptions>;
};


export type TeamswithSportQuery = { __typename?: 'Query', teams: Array<{ __typename?: 'Team', id: number, name: string, sportId: number }> };

export type ThemeFragment = { __typename?: 'Theme', id: number, name: string, sportId: number, sportName: string, usedBy?: Maybe<Array<{ __typename?: 'Competition', name: string, id: number }>> };

export type ThemeQueryVariables = {
  id: Scalars['Float'];
};


export type ThemeQuery = { __typename?: 'Query', theme: (
    { __typename?: 'Theme' }
    & ThemeFragment
  ) };

export type ThemesQueryVariables = {};


export type ThemesQuery = { __typename?: 'Query', themes: Array<{ __typename?: 'Theme', id: number, name: string, sportId: number, sportName: string, usedBy?: Maybe<Array<{ __typename?: 'Competition', name: string, id: number }>> }> };

export type VenueQueryVariables = {
  id: Scalars['Float'];
};


export type VenueQuery = { __typename?: 'Query', venue: { __typename?: 'Venue', id: number, name: string, gfxName?: Maybe<string>, lat?: Maybe<number>, lng?: Maybe<number>, city?: Maybe<string>, state?: Maybe<string>, country?: Maybe<string>, postcode?: Maybe<string>, address?: Maybe<string>, countMatches: number, countDefaultVenue: number, archived: boolean, baseEntity?: Maybe<{ __typename?: 'VenueBase', id: number, name: string }> } };

export type VenuesQueryVariables = {
  options?: Maybe<IQueryOptions>;
};


export type VenuesQuery = { __typename?: 'Query', venues: Array<{ __typename?: 'Venue', id: number, name: string, lat?: Maybe<number>, lng?: Maybe<number>, city?: Maybe<string>, country?: Maybe<string>, state?: Maybe<string>, postcode?: Maybe<string>, address?: Maybe<string>, countDefaultVenue: number, countMatches: number, archived: boolean }> };

export type MeQueryVariables = {};


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'Me', id: number, admin?: Maybe<boolean>, firstName: string, lastName: string, email: string, organizations: Array<{ __typename?: 'Organization', id: number, name: string }>, photo?: Maybe<{ __typename?: 'File', id: number, url: string }> } };

export type CurrentOrganizationQueryVariables = {};


export type CurrentOrganizationQuery = { __typename?: 'Query', currentOrganization: { __typename?: 'Organization', id: number, name: string, default: boolean, manualPayment: boolean, stripeCustomerId?: Maybe<string>, stripePlanId?: Maybe<string>, stripeCardLast4?: Maybe<string>, planQuantity?: Maybe<number>, blocked: boolean, logo?: Maybe<{ __typename?: 'File', id: number, url: string }> } };

export type RestoreAdSetMutationVariables = {
  id: Scalars['Float'];
};


export type RestoreAdSetMutation = { __typename?: 'Mutation', restoreAdSet: boolean };

export type DeleteClubMutationVariables = {
  id: Scalars['Float'];
};


export type DeleteClubMutation = { __typename?: 'Mutation', deleteClub: boolean };

export type RestoreClubMutationVariables = {
  id: Scalars['Float'];
};


export type RestoreClubMutation = { __typename?: 'Mutation', restoreClub: boolean };

export type DeleteCompetitionMutationVariables = {
  id: Scalars['Float'];
};


export type DeleteCompetitionMutation = { __typename?: 'Mutation', deleteCompetition: boolean };

export type RestoreCompetitionMutationVariables = {
  id: Scalars['Float'];
};


export type RestoreCompetitionMutation = { __typename?: 'Mutation', restoreCompetition: boolean };

export type DeleteMatchMutationVariables = {
  id: Scalars['Float'];
};


export type DeleteMatchMutation = { __typename?: 'Mutation', deleteMatch: boolean };

export type RestoreMatchMutationVariables = {
  id: Scalars['Float'];
};


export type RestoreMatchMutation = { __typename?: 'Mutation', restoreMatch: boolean };

export type RestorePlayerMutationVariables = {
  id: Scalars['Float'];
};


export type RestorePlayerMutation = { __typename?: 'Mutation', restorePlayer: boolean };

export type DeleteTeamMutationVariables = {
  id: Scalars['Float'];
};


export type DeleteTeamMutation = { __typename?: 'Mutation', deleteTeam: boolean };

export type RestoreTeamMutationVariables = {
  id: Scalars['Float'];
};


export type RestoreTeamMutation = { __typename?: 'Mutation', restoreTeam: boolean };

export type DeleteVenueMutationVariables = {
  id: Scalars['Float'];
};


export type DeleteVenueMutation = { __typename?: 'Mutation', deleteVenue: boolean };

export type RestoreVenueMutationVariables = {
  id: Scalars['Float'];
};


export type RestoreVenueMutation = { __typename?: 'Mutation', restoreVenue: boolean };

export type CreateOrganizationMutationVariables = {
  createOrganizationInput: CreateOrganizationInput;
};


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'Organization', id: number, name: string } };

export type SearchOrganizationsQueryVariables = {
  query: Scalars['String'];
};


export type SearchOrganizationsQuery = { __typename?: 'Query', searchOrganizations: Array<{ __typename?: 'Organization', id: number, name: string }> };

export type CreateOrganizationAdapterMutationVariables = {
  createOrganizationAdapterInput: CreateOrganizationAdapterInput;
};


export type CreateOrganizationAdapterMutation = { __typename?: 'Mutation', createOrganizationAdapter: { __typename?: 'OrganizationAdapter', id: number, providerName: string, providerCompetitionId: number, organization: { __typename?: 'Organization', id: number, name: string } } };

export type InviteMutationVariables = {
  user: InviteUserInput;
};


export type InviteMutation = { __typename?: 'Mutation', invite: { __typename?: 'UserOrganization', role: string, organizationId: number, user: { __typename?: 'User', id: number, lastName: string, firstName: string, email: string } } };

export type UpdatePermissionMutationVariables = {
  userId: Scalars['Float'];
  role: Scalars['String'];
};


export type UpdatePermissionMutation = { __typename?: 'Mutation', updatePermission: { __typename?: 'UserOrganization', id: number, organizationId: number, role: string, user: { __typename?: 'User', id: number, lastName: string, firstName: string, email: string } } };

export type PermissionQueryVariables = {
  userId: Scalars['Float'];
};


export type PermissionQuery = { __typename?: 'Query', permission: { __typename?: 'UserOrganization', id: number, organizationId: number, role: string, user: { __typename?: 'User', id: number, lastName: string, firstName: string, email: string } } };

export type SearchOrganizationAdaptersQueryVariables = {
  query: Scalars['String'];
};


export type SearchOrganizationAdaptersQuery = { __typename?: 'Query', searchOrganizationAdapters: Array<{ __typename?: 'OrganizationAdapter', id: number, providerName: string, providerCompetitionId: number, organization: { __typename?: 'Organization', id: number, name: string } }> };

export type DeleteOrganizationAdapterMutationVariables = {
  id: Scalars['Float'];
};


export type DeleteOrganizationAdapterMutation = { __typename?: 'Mutation', deleteOrganizationAdapter: boolean };

export type SearchCompetitionsQueryVariables = {
  query: Scalars['String'];
};


export type SearchCompetitionsQuery = { __typename?: 'Query', searchCompetitions: Array<{ __typename?: 'Competition', id: number, name: string, baseId?: Maybe<number>, organization: { __typename?: 'Organization', id: number, name: string }, baseEntity?: Maybe<{ __typename?: 'CompetitionBase', id: number, name: string, providerId: number, providerName: string }> }> };

export type UpdateCompetitionAdminMutationVariables = {
  updateCompetitionInput: UpdateCompetitionAdminInput;
};


export type UpdateCompetitionAdminMutation = { __typename?: 'Mutation', updateCompetitionAdmin: { __typename?: 'Competition', id: number, name: string, baseId?: Maybe<number>, baseEntity?: Maybe<{ __typename?: 'CompetitionBase', id: number, name: string, providerId: number, providerName: string }> } };

export type SearchOrganizationsWithPaymentQueryVariables = {
  query: Scalars['String'];
};


export type SearchOrganizationsWithPaymentQuery = { __typename?: 'Query', searchOrganizations: Array<{ __typename?: 'Organization', id: number, name: string, manualPayment: boolean, stripeCustomerId?: Maybe<string>, stripePlanId?: Maybe<string>, stripeCardLast4?: Maybe<string>, planQuantity?: Maybe<number>, blocked: boolean }> };

export type ToggleManualPaymentForOrganizationMutationVariables = {
  organizationId: Scalars['Float'];
};


export type ToggleManualPaymentForOrganizationMutation = { __typename?: 'Mutation', toggleManualPaymentForOrganization: { __typename?: 'Organization', id: number, name: string, manualPayment: boolean, stripeCustomerId?: Maybe<string>, stripePlanId?: Maybe<string>, stripeCardLast4?: Maybe<string>, planQuantity?: Maybe<number>, blocked: boolean } };

export type ToggleBlockOrganizationMutationVariables = {
  organizationId: Scalars['Float'];
};


export type ToggleBlockOrganizationMutation = { __typename?: 'Mutation', toggleBlockOrganization: { __typename?: 'Organization', id: number, name: string, manualPayment: boolean, stripeCustomerId?: Maybe<string>, stripePlanId?: Maybe<string>, stripeCardLast4?: Maybe<string>, planQuantity?: Maybe<number>, blocked: boolean } };

export type SearchUsersQueryVariables = {
  query: Scalars['String'];
};


export type SearchUsersQuery = { __typename?: 'Query', searchUsers: Array<{ __typename?: 'User', id: number, firstName: string, lastName: string, email: string, blocked: boolean, admin: boolean }> };

export type ToggleBlockUserMutationVariables = {
  userId: Scalars['Float'];
};


export type ToggleBlockUserMutation = { __typename?: 'Mutation', toggleBlockUser: { __typename?: 'User', id: number, firstName: string, lastName: string, email: string, blocked: boolean, admin: boolean } };

export type ToggleAdminUserMutationVariables = {
  userId: Scalars['Float'];
};


export type ToggleAdminUserMutation = { __typename?: 'Mutation', toggleAdminUser: { __typename?: 'User', id: number, firstName: string, lastName: string, email: string, blocked: boolean, admin: boolean } };

export type CompetitionBasesQueryVariables = {};


export type CompetitionBasesQuery = { __typename?: 'Query', competitionBases: Array<{ __typename?: 'CompetitionBase', id: number, name: string, providerId: number, providerName: string }> };

export type AdSetsQueryVariables = {
  options?: Maybe<IQueryOptions>;
};


export type AdSetsQuery = { __typename?: 'Query', adSets: Array<{ __typename?: 'AdSet', id: number, name: string, countAdAllocations: number, adFiles: Array<{ __typename?: 'AdFile', id: number, adSetId: number, size: string, file?: Maybe<{ __typename?: 'File', id: number, url: string, entityId: number, entityType: FileEntityType }> }> }> };

export type UpdateAdSetMutationVariables = {
  updateAdSetInput: UpdateAdSetInput;
};


export type UpdateAdSetMutation = { __typename?: 'Mutation', updateAdSet: { __typename?: 'AdSet', id: number, name: string } };

export type AdSetsWithFilesQueryVariables = {
  options?: Maybe<IQueryOptions>;
};


export type AdSetsWithFilesQuery = { __typename?: 'Query', adSets: Array<{ __typename?: 'AdSet', id: number, name: string, countAdAllocations: number, archived: boolean, adFiles: Array<{ __typename?: 'AdFile', id: number, adSetId: number, size: string, file?: Maybe<{ __typename?: 'File', id: number, url: string, entityId: number, entityType: FileEntityType }> }> }> };

export type AdSetQueryVariables = {
  id: Scalars['Float'];
};


export type AdSetQuery = { __typename?: 'Query', adSet: { __typename?: 'AdSet', id: number, name: string, archived: boolean, countAdAllocations: number, adFiles: Array<{ __typename?: 'AdFile', id: number, adSetId: number, size: string, file?: Maybe<{ __typename?: 'File', id: number, url: string, entityId: number, entityType: FileEntityType }> }> } };

export type UpdateEntityAdAllocationMutationVariables = {
  entityAdAllocationUpdate: EntityAdAllocationUpdate;
};


export type UpdateEntityAdAllocationMutation = { __typename?: 'Mutation', updateEntityAdAllocation: boolean };

export type AdSetsWithAllocationsQueryVariables = {
  options?: Maybe<IQueryOptions>;
};


export type AdSetsWithAllocationsQuery = { __typename?: 'Query', adSets: Array<{ __typename?: 'AdSet', id: number, name: string, adSetAllocations?: Maybe<Array<{ __typename?: 'AdsetAllocation', events?: Maybe<Array<string>>, percentage?: Maybe<number>, id: number }>> }> };

export type CompForMenuQueryVariables = {};


export type CompForMenuQuery = { __typename?: 'Query', competitions: Array<{ __typename?: 'Competition', id: number, name: string, logo?: Maybe<{ __typename?: 'File', id: number, url: string }> }> };

export type SearchPlayersQueryVariables = {
  options?: Maybe<IQueryOptions>;
  searchFromStart?: Maybe<Scalars['Boolean']>;
  searchOnFields: Array<Scalars['String']>;
  searchStr: Scalars['String'];
};


export type SearchPlayersQuery = { __typename?: 'Query', searchPlayers: Array<{ __typename?: 'Player', id: number, firstName: string, lastName: string, playsFor?: Maybe<Array<{ __typename?: 'TeamWithPlayerPhoto', team: { __typename?: 'Team', id: number, logo?: Maybe<{ __typename?: 'File', id: number, url: string }> }, photo?: Maybe<{ __typename?: 'File', id: number, url: string }> }>> }> };

export type UpdateTeamCustomizeMutationVariables = {
  updateTeamInput: UpdateTeamInput;
  clubOverride?: Maybe<Scalars['Boolean']>;
};


export type UpdateTeamCustomizeMutation = { __typename?: 'Mutation', updateTeam: { __typename?: 'Team', id: number, name: string, gfxName?: Maybe<string>, gfxFullName?: Maybe<string>, abbreviation?: Maybe<string>, primaryBackgroundColor?: Maybe<string>, primaryTextColor?: Maybe<string>, secondaryBackgroundColor?: Maybe<string>, secondaryTextColor?: Maybe<string>, defaultVenueId?: Maybe<number>, logo?: Maybe<{ __typename?: 'File', id: number, url: string }> } };

export type UpdateTeamSettingsMutationVariables = {
  updateTeamInput: UpdateTeamInput;
};


export type UpdateTeamSettingsMutation = { __typename?: 'Mutation', updateTeam: { __typename?: 'Team', id: number, age: Age, gender: Gender, club?: Maybe<{ __typename?: 'Club', id: number }>, grade: { __typename?: 'Grade', id: number }, sport: { __typename?: 'Sport', id: number, name: string }, competitions: Array<{ __typename?: 'Competition', id: number, name: string }> } };

export type FullTeamFragment = { __typename?: 'Team', id: number, name: string, gfxName?: Maybe<string>, gfxFullName?: Maybe<string>, abbreviation?: Maybe<string>, primaryBackgroundColor?: Maybe<string>, primaryTextColor?: Maybe<string>, secondaryBackgroundColor?: Maybe<string>, secondaryTextColor?: Maybe<string>, organizationId: number, defaultVenueId?: Maybe<number>, sport: { __typename?: 'Sport', id: number, name: string }, competitions: Array<{ __typename?: 'Competition', id: number, name: string }>, logo?: Maybe<{ __typename?: 'File', id: number, url: string }> };

export type UpdateTeamMutationVariables = {
  updateTeamInput: UpdateTeamInput;
};


export type UpdateTeamMutation = { __typename?: 'Mutation', updateTeam: (
    { __typename?: 'Team' }
    & FullTeamFragment
  ) };

export type ClubsAndTeamsMenuQueryVariables = {};


export type ClubsAndTeamsMenuQuery = { __typename?: 'Query', clubsAndTeams: Array<{ __typename?: 'Club', id: number, name: string, logo?: Maybe<{ __typename?: 'File', id: number, url: string }>, teams?: Maybe<Array<{ __typename?: 'Team', id: number, age: Age, gender: Gender, grade: { __typename?: 'Grade', id: number, name: string } }>> } | { __typename?: 'Team', id: number, name: string, logo?: Maybe<{ __typename?: 'File', id: number, url: string }> }> };

export type PasswordResetMutationVariables = {
  email: Scalars['String'];
};


export type PasswordResetMutation = { __typename?: 'Mutation', passwordReset: boolean };

export type BasicMatchFragment = { __typename?: 'Match', id: number, name: string, organizationId: number, awayTeamId: number, homeTeamId: number, venueId: number, competitionId: number, description?: Maybe<string>, date: any, config: any, sportName: string, hasFacts: boolean, baseEntity?: Maybe<{ __typename?: 'MatchBase', id: number, providerId: number, providerName: string }>, competition: { __typename?: 'Competition', id: number, name: string, teams: Array<{ __typename?: 'Team', name: string, id: number }>, sport: { __typename?: 'Sport', id: number, name: string } }, homeTeam: { __typename?: 'Team', id: number, name: string }, awayTeam: { __typename?: 'Team', id: number, name: string }, venue: { __typename?: 'Venue', id: number, name: string } };

export type BasicMatchQueryVariables = {
  id: Scalars['Float'];
};


export type BasicMatchQuery = { __typename?: 'Query', match: (
    { __typename?: 'Match' }
    & BasicMatchFragment
  ) };

export type MatchQueryVariables = {
  id: Scalars['Float'];
};


export type MatchQuery = { __typename?: 'Query', match: { __typename?: 'Match', name: string, hasFacts: boolean, date: any, id: number, sportName: string, config: any, competition: { __typename?: 'Competition', id: number, name: string, teams: Array<{ __typename?: 'Team', name: string, id: number }>, sport: { __typename?: 'Sport', name: string, id: number } }, venue: { __typename?: 'Venue', id: number, name: string }, homeTeam: { __typename?: 'Team', id: number, name: string }, awayTeam: { __typename?: 'Team', id: number, name: string }, baseEntity?: Maybe<{ __typename?: 'MatchBase', id: number, providerId: number, providerName: string }> } };

export type UpdateOverlayMutationVariables = {
  updateOverlayInput: UpdateOverlayInput;
};


export type UpdateOverlayMutation = { __typename?: 'Mutation', updateOverlay: { __typename?: 'Overlay', id: number, name: string, matchId: number, encodingDelay: number, autoMode: boolean, testMode: boolean, resolution: number, showWatermarks: boolean, background: string, backgroundColor?: Maybe<string>, enableAds: boolean, key: string } };

export type CreateOverlayMutationVariables = {
  createOverlayInput: CreateOverlayInput;
};


export type CreateOverlayMutation = { __typename?: 'Mutation', createOverlay: { __typename?: 'Overlay', id: number, matchId: number, name: string, encodingDelay: number, autoMode: boolean, testMode: boolean, resolution: number, showWatermarks: boolean, background: string, backgroundColor?: Maybe<string>, enableAds: boolean, key: string } };

export type DeleteOverlayMutationVariables = {
  id: Scalars['Float'];
};


export type DeleteOverlayMutation = { __typename?: 'Mutation', deleteOverlay: boolean };

export type OverlayQueryVariables = {
  id: Scalars['Float'];
};


export type OverlayQuery = { __typename?: 'Query', overlay: { __typename?: 'Overlay', id: number, matchId: number, name: string, encodingDelay: number, autoMode: boolean, testMode: boolean, resolution: number, showWatermarks: boolean, background: string, backgroundColor?: Maybe<string>, enableAds: boolean, key: string } };

export type MatchesSubscriptionSubscriptionVariables = {
  matchesSubscriptionArgs: MatchesSubscriptionArgs;
};


export type MatchesSubscriptionSubscription = { __typename?: 'Subscription', matchesSubscription: { __typename?: 'MatchesSubscriptionUpdates', topic: string, match: { __typename?: 'Match', id: number, date: any, finishedStatus: string, coverage?: Maybe<boolean>, hasFacts: boolean, sportName: string, lineup: Array<{ __typename?: 'MatchPlayer', id: number, position?: Maybe<string>, number?: Maybe<string>, captain?: Maybe<boolean>, starting?: Maybe<boolean>, photo?: Maybe<{ __typename?: 'File', id: number, url: string }>, player: { __typename?: 'Player', id: number, firstName: string, lastName: string }, team: { __typename?: 'Team', id: number, abbreviation?: Maybe<string> } }>, overlays: Array<{ __typename?: 'Overlay', id: number, matchId: number, name: string, encodingDelay: number, autoMode: boolean, testMode: boolean, resolution: number, showWatermarks: boolean, background: string, backgroundColor?: Maybe<string>, enableAds: boolean, key: string }>, summary: { __typename?: 'MatchSummary', matchId: number, currentPeriod: string, periods: Array<{ __typename?: 'MatchPeriod', duration?: Maybe<number>, name: string, preOvertimeBreak?: Maybe<boolean>, code: string, status: PeriodStatus, type: PeriodType, aboutToStart?: Maybe<boolean>, playersEntered?: Maybe<boolean>, started?: Maybe<any>, finished?: Maybe<any>, shootout?: Maybe<boolean>, matchFinished?: Maybe<boolean> }>, matchStats: { __typename?: 'MatchStats', score: { __typename?: 'Score', home: number, away: number } }, clock: { __typename?: 'ClockInfo', clockRunning: boolean, clockInMs: number, clockChangeDate?: Maybe<any> } }, homeTeam: { __typename?: 'Team', id: number, name: string, gfxName?: Maybe<string>, abbreviation?: Maybe<string>, logo?: Maybe<{ __typename?: 'File', id: number, url: string, entityType: FileEntityType, entityId: number }> }, awayTeam: { __typename?: 'Team', id: number, abbreviation?: Maybe<string>, name: string, gfxName?: Maybe<string>, logo?: Maybe<{ __typename?: 'File', id: number, url: string, entityType: FileEntityType, entityId: number }> }, competition: { __typename?: 'Competition', id: number, name: string, logo?: Maybe<{ __typename?: 'File', id: number, url: string, entityType: FileEntityType, entityId: number }> } } } };

export type MatchSubscriptionSubscriptionVariables = {
  matchSubscriptionArgs: MatchSubscriptionArgs;
};


export type MatchSubscriptionSubscription = { __typename?: 'Subscription', matchSubscription: { __typename?: 'MatchUpdate', match: { __typename?: 'Match', id: number, name: string, organizationId: number, awayTeamId: number, homeTeamId: number, venueId: number, sportName: string, competitionId: number, description?: Maybe<string>, finishedStatus: string, date: any, lineup: Array<{ __typename?: 'MatchPlayer', id: number, position?: Maybe<string>, number?: Maybe<string>, starting?: Maybe<boolean>, captain?: Maybe<boolean>, photo?: Maybe<{ __typename?: 'File', id: number, url: string }>, player: { __typename?: 'Player', id: number, firstName: string, lastName: string }, team: { __typename?: 'Team', id: number, abbreviation?: Maybe<string> } }>, awayTeam: { __typename?: 'Team', id: number, abbreviation?: Maybe<string>, name: string, logo?: Maybe<{ __typename?: 'File', id: number, url: string, entityType: FileEntityType, entityId: number }> }, homeTeam: { __typename?: 'Team', id: number, abbreviation?: Maybe<string>, name: string, logo?: Maybe<{ __typename?: 'File', id: number, url: string, entityType: FileEntityType, entityId: number }> }, venue: { __typename?: 'Venue', id: number, name: string } } } };

export type FullMatchFragment = { __typename?: 'Match', id: number, name: string, awayTeamId: number, homeTeamId: number, venueId: number, competitionId: number, description?: Maybe<string>, date: any, finishedStatus: string, liveStatus: PeriodStatus, config: any, sportName: string, lineup: Array<{ __typename?: 'MatchPlayer', id: number, position?: Maybe<string>, number?: Maybe<string>, starting?: Maybe<boolean>, captain?: Maybe<boolean>, photo?: Maybe<{ __typename?: 'File', id: number, url: string }>, player: { __typename?: 'Player', id: number, firstName: string, lastName: string }, team: { __typename?: 'Team', id: number, abbreviation?: Maybe<string> } }>, venue: { __typename?: 'Venue', id: number, name: string }, competition: { __typename?: 'Competition', id: number, themeId: number, logo?: Maybe<{ __typename?: 'File', id: number, url: string }>, theme: { __typename?: 'Theme', id: number, name: string, sportName: string, sportId: number }, adAllocation?: Maybe<{ __typename?: 'EntityAdAllocation', id: number, adSets: Array<{ __typename?: 'AdSet', id: number, name: string, adFiles: Array<{ __typename?: 'AdFile', id: number, adSetId: number, size: string, file?: Maybe<{ __typename?: 'File', id: number, url: string, entityId: number, entityType: FileEntityType }> }> }> }> }, summary: (
    { __typename?: 'MatchSummary' }
    & SummaryFragment
  ), overlays: Array<{ __typename?: 'Overlay', id: number, matchId: number, encodingDelay: number, autoMode: boolean, resolution: number, showWatermarks: boolean, background: string, backgroundColor?: Maybe<string>, enableAds: boolean, manualGraphicState: any, name: string, key: string }>, homeTeam: { __typename?: 'Team', id: number, name: string, gfxName?: Maybe<string>, abbreviation?: Maybe<string>, gfxFullName?: Maybe<string>, logo?: Maybe<{ __typename?: 'File', id: number, url: string }>, adAllocation?: Maybe<{ __typename?: 'EntityAdAllocation', id: number, adSets: Array<{ __typename?: 'AdSet', id: number, name: string, adFiles: Array<{ __typename?: 'AdFile', id: number, adSetId: number, size: string, file?: Maybe<{ __typename?: 'File', id: number, url: string, entityId: number, entityType: FileEntityType }> }> }> }> }, awayTeam: { __typename?: 'Team', id: number, name: string, gfxName?: Maybe<string>, abbreviation?: Maybe<string>, gfxFullName?: Maybe<string>, logo?: Maybe<{ __typename?: 'File', id: number, url: string }>, adAllocation?: Maybe<{ __typename?: 'EntityAdAllocation', id: number, adSets: Array<{ __typename?: 'AdSet', id: number, name: string, adFiles: Array<{ __typename?: 'AdFile', id: number, adSetId: number, size: string, file?: Maybe<{ __typename?: 'File', id: number, url: string, entityId: number, entityType: FileEntityType }> }> }> }> } };

export type FullMatchQueryVariables = {
  id: Scalars['Float'];
};


export type FullMatchQuery = { __typename?: 'Query', match: (
    { __typename?: 'Match' }
    & FullMatchFragment
  ) };

export type MatchSubSubscriptionVariables = {
  matchSubscriptionArgs: MatchSubscriptionArgs;
};


export type MatchSubSubscription = { __typename?: 'Subscription', matchSubscription: { __typename?: 'MatchUpdate', match: { __typename?: 'Match', id: number, name: string, organizationId: number, awayTeamId: number, homeTeamId: number, venueId: number, competitionId: number, description?: Maybe<string>, finishedStatus: string, sportName: string, date: any, config: any, liveStatus: PeriodStatus, awayTeam: { __typename?: 'Team', id: number, abbreviation?: Maybe<string>, name: string, gfxName?: Maybe<string>, logo?: Maybe<{ __typename?: 'File', id: number, url: string, entityType: FileEntityType, entityId: number }>, adAllocation?: Maybe<{ __typename?: 'EntityAdAllocation', id: number, adSets: Array<{ __typename?: 'AdSet', id: number, name: string, adFiles: Array<{ __typename?: 'AdFile', id: number, adSetId: number, size: string, file?: Maybe<{ __typename?: 'File', id: number, url: string, entityId: number, entityType: FileEntityType }> }> }> }> }, homeTeam: { __typename?: 'Team', id: number, abbreviation?: Maybe<string>, gfxName?: Maybe<string>, name: string, logo?: Maybe<{ __typename?: 'File', id: number, url: string, entityType: FileEntityType, entityId: number }>, adAllocation?: Maybe<{ __typename?: 'EntityAdAllocation', id: number, adSets: Array<{ __typename?: 'AdSet', id: number, name: string, adFiles: Array<{ __typename?: 'AdFile', id: number, adSetId: number, size: string, file?: Maybe<{ __typename?: 'File', id: number, url: string, entityId: number, entityType: FileEntityType }> }> }> }> }, lineup: Array<{ __typename?: 'MatchPlayer', id: number, position?: Maybe<string>, number?: Maybe<string>, starting?: Maybe<boolean>, captain?: Maybe<boolean>, photo?: Maybe<{ __typename?: 'File', id: number, url: string }>, player: { __typename?: 'Player', id: number, firstName: string, lastName: string }, team: { __typename?: 'Team', id: number, abbreviation?: Maybe<string> } }>, venue: { __typename?: 'Venue', id: number, name: string }, competition: { __typename?: 'Competition', id: number, themeId: number, logo?: Maybe<{ __typename?: 'File', id: number, url: string }>, theme: { __typename?: 'Theme', id: number, name: string, sportName: string, sportId: number }, adAllocation?: Maybe<{ __typename?: 'EntityAdAllocation', id: number, adSets: Array<{ __typename?: 'AdSet', id: number, name: string, adFiles: Array<{ __typename?: 'AdFile', id: number, adSetId: number, size: string, file?: Maybe<{ __typename?: 'File', id: number, url: string, entityId: number, entityType: FileEntityType }> }> }> }> }, overlays: Array<{ __typename?: 'Overlay', id: number, matchId: number, encodingDelay: number, autoMode: boolean, resolution: number, showWatermarks: boolean, background: string, backgroundColor?: Maybe<string>, enableAds: boolean, manualGraphicState: any, name: string, key: string }> } } };

export type OverlayWithFullMatchQueryVariables = {
  id: Scalars['Float'];
};


export type OverlayWithFullMatchQuery = { __typename?: 'Query', overlay: { __typename?: 'Overlay', id: number, matchId: number, encodingDelay: number, autoMode: boolean, resolution: number, showWatermarks: boolean, background: string, backgroundColor?: Maybe<string>, enableAds: boolean, name: string, testMode: boolean, manualGraphicState: any, key: string, match: { __typename?: 'Match', id: number, name: string, awayTeamId: number, homeTeamId: number, venueId: number, competitionId: number, description?: Maybe<string>, date: any, config: any, finishedStatus: string, liveStatus: PeriodStatus, hasFacts: boolean, sportName: string, organizationId: number, venue: { __typename?: 'Venue', id: number, name: string }, lineup: Array<{ __typename?: 'MatchPlayer', id: number, position?: Maybe<string>, number?: Maybe<string>, starting?: Maybe<boolean>, captain?: Maybe<boolean>, photo?: Maybe<{ __typename?: 'File', id: number, url: string }>, player: { __typename?: 'Player', id: number, firstName: string, lastName: string }, team: { __typename?: 'Team', id: number, abbreviation?: Maybe<string> } }>, facts: Array<{ __typename?: 'Fact', matchId: number, id: number, name: FactName, teamId?: Maybe<number>, playerId?: Maybe<number>, minute?: Maybe<number>, date: any, period: string, data?: Maybe<any> }>, competition: { __typename?: 'Competition', id: number, themeId: number, logo?: Maybe<{ __typename?: 'File', id: number, url: string }>, theme: { __typename?: 'Theme', id: number, name: string, sportName: string, sportId: number }, adAllocation?: Maybe<{ __typename?: 'EntityAdAllocation', id: number, adSets: Array<{ __typename?: 'AdSet', id: number, name: string, adFiles: Array<{ __typename?: 'AdFile', id: number, adSetId: number, size: string, file?: Maybe<{ __typename?: 'File', id: number, url: string, entityId: number, entityType: FileEntityType }> }> }> }> }, summary: (
        { __typename?: 'MatchSummary' }
        & SummaryFragment
      ), homeTeam: { __typename?: 'Team', id: number, name: string, gfxName?: Maybe<string>, gfxFullName?: Maybe<string>, abbreviation?: Maybe<string>, logo?: Maybe<{ __typename?: 'File', id: number, url: string }>, adAllocation?: Maybe<{ __typename?: 'EntityAdAllocation', id: number, adSets: Array<{ __typename?: 'AdSet', id: number, name: string, adFiles: Array<{ __typename?: 'AdFile', id: number, adSetId: number, size: string, file?: Maybe<{ __typename?: 'File', id: number, url: string, entityId: number, entityType: FileEntityType }> }> }> }> }, awayTeam: { __typename?: 'Team', id: number, name: string, gfxName?: Maybe<string>, gfxFullName?: Maybe<string>, abbreviation?: Maybe<string>, logo?: Maybe<{ __typename?: 'File', id: number, url: string }>, adAllocation?: Maybe<{ __typename?: 'EntityAdAllocation', id: number, adSets: Array<{ __typename?: 'AdSet', id: number, name: string, adFiles: Array<{ __typename?: 'AdFile', id: number, adSetId: number, size: string, file?: Maybe<{ __typename?: 'File', id: number, url: string, entityId: number, entityType: FileEntityType }> }> }> }> } } } };

export type MatchFactFeedSubscriptionVariables = {
  id: Scalars['Float'];
};


export type MatchFactFeedSubscription = { __typename?: 'Subscription', matchFeed: { __typename?: 'MatchFeedBroadcast', facts: Array<{ __typename?: 'Fact', matchId: number, id: number, name: FactName, teamId?: Maybe<number>, playerId?: Maybe<number>, minute?: Maybe<number>, date: any, period: string, data?: Maybe<any> }> } };

export type Unnamed_1_QueryVariables = {};


export type Unnamed_1_Query = { __typename?: 'Query', invoices?: Maybe<Array<{ __typename?: 'Invoice', status: string, amountDue: number, currency: string, plan: string, pdfLink: string, period: { __typename?: 'InvoicePeriod', start: any, end: any } }>> };

export type UpdateOrganizationMutationVariables = {
  org: UpdateOrganizationInput;
};


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'Organization', id: number, name: string, default: boolean, logo?: Maybe<{ __typename?: 'File', id: number, url: string }> } };

export type MakeDefaultOrganizationMutationVariables = {};


export type MakeDefaultOrganizationMutation = { __typename?: 'Mutation', makeDefaultOrganization: { __typename?: 'Organization', id: number, name: string, default: boolean, logo?: Maybe<{ __typename?: 'File', id: number, url: string }> } };

export type UpdatePasswordWithCurrentMutationVariables = {
  newPassword: Scalars['String'];
  currentPassword: Scalars['String'];
};


export type UpdatePasswordWithCurrentMutation = { __typename?: 'Mutation', updatePasswordWithCurrent: boolean };

export type PermissionFragment = { __typename?: 'UserOrganization', organizationId: number, role: string, user: { __typename?: 'User', id: number, lastName: string, firstName: string, email: string } };

export type PermissionsQueryVariables = {};


export type PermissionsQuery = { __typename?: 'Query', permissions: Array<(
    { __typename?: 'UserOrganization' }
    & PermissionFragment
  )> };

export type RevokeMutationVariables = {
  userId: Scalars['Float'];
};


export type RevokeMutation = { __typename?: 'Mutation', revoke: boolean };

export type TransferOwnershipMutationVariables = {
  userId: Scalars['Float'];
};


export type TransferOwnershipMutation = { __typename?: 'Mutation', transferOwnership: { __typename?: 'UserOrganization', organizationId: number, role: string, user: { __typename?: 'User', id: number, lastName: string, firstName: string, email: string } } };

export type UpdateUserMutationVariables = {
  userInput: UpdateUserInput;
};


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: number, firstName: string, lastName: string, email: string } };

export type CreateOrUpdateSubscriptionMutationVariables = {
  plan: Scalars['String'];
  quantity: Scalars['Float'];
  source?: Maybe<Scalars['String']>;
  ccLast4?: Maybe<Scalars['String']>;
};


export type CreateOrUpdateSubscriptionMutation = { __typename?: 'Mutation', createOrUpdateSubscription: { __typename?: 'Organization', id: number, stripeCustomerId?: Maybe<string>, stripePlanId?: Maybe<string>, stripeCardLast4?: Maybe<string> } };

export type UpdateCardMutationVariables = {
  source: Scalars['String'];
  ccLast4: Scalars['String'];
};


export type UpdateCardMutation = { __typename?: 'Mutation', updateCard: { __typename?: 'Organization', id: number, stripeCustomerId?: Maybe<string>, stripePlanId?: Maybe<string>, stripeCardLast4?: Maybe<string> } };

export type CancelSubscriptionMutationVariables = {
  reason: Scalars['String'];
};


export type CancelSubscriptionMutation = { __typename?: 'Mutation', cancelSubscription: { __typename?: 'Organization', id: number, stripeCustomerId?: Maybe<string>, stripePlanId?: Maybe<string>, stripeCardLast4?: Maybe<string> } };

export type RegisterMutationVariables = {
  registerInput: RegisterInput;
};


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'RegisterOutput', user: { __typename?: 'RegisteredUser', id: number, firstName: string, lastName: string, email: string }, organization: { __typename?: 'RegisteredOrganization', name: string } } };

export type OrgFragment = { __typename?: 'Organization', id: number, name: string, blocked: boolean, logo?: Maybe<{ __typename?: 'File', id: number, url: string }> };

export type MeFragment = { __typename?: 'UserOrganization', id: number, organizationId: number, default: boolean, organization: (
    { __typename?: 'Organization' }
    & OrgFragment
  ), user: { __typename?: 'User', id: number } };

export type MePermissionQueryVariables = {};


export type MePermissionQuery = { __typename?: 'Query', mePermission: Array<(
    { __typename?: 'UserOrganization' }
    & MeFragment
  )> };

export type UpdatePasswordMutationVariables = {
  updatePassword: UpdatePasswordInput;
};


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: boolean };

export type ConfirmEmailMutationVariables = {
  token: Scalars['String'];
};


export type ConfirmEmailMutation = { __typename?: 'Mutation', confirmEmail: boolean };

export type AdAllocationFragment = { __typename?: 'EntityAdAllocation', id: number, adSets: Array<{ __typename?: 'AdSet', id: number, name: string, teamId?: Maybe<number>, adSetAllocations?: Maybe<Array<{ __typename?: 'AdsetAllocation', id: number, percentage?: Maybe<number>, events?: Maybe<Array<string>>, entityAdAllocationId: number }>>, adFiles: Array<{ __typename?: 'AdFile', size: string, adSetId: number, file?: Maybe<{ __typename?: 'File', url: string, id: number }> }> }>, config?: Maybe<{ __typename?: 'EntityAdAllocationConfig', events: any, teams: { __typename?: 'AdAllocationTeamConfig', home: { __typename?: 'TeamAllocationConfig', percentage: number, enabled: boolean }, away: { __typename?: 'TeamAllocationConfig', percentage: number, enabled: boolean } }, loop: { __typename?: 'AdAllocationLoopConfig', enabled: boolean, type: string, secsBetweenShows: number, secsPerShow: number, perPeriod: number } }> };

export type AdFileFragment = { __typename?: 'AdFile', id: number, adSetId: number, size: string, file?: Maybe<(
    { __typename?: 'File' }
    & FileFragment
  )> };

export type CompetitionAdAllocationFragment = { __typename?: 'EntityAdAllocation', id: number, entityId: number, entity: { __typename?: 'Team', id: number, name: string, sport: { __typename?: 'Sport', id: number, name: string } } | { __typename?: 'Competition', id: number, name: string, sport: { __typename?: 'Sport', id: number, name: string } }, adSets: Array<{ __typename?: 'AdSet', id: number, name: string, teamId?: Maybe<number>, adSetAllocations?: Maybe<Array<{ __typename?: 'AdsetAllocation', id: number, percentage?: Maybe<number>, events?: Maybe<Array<string>>, entityAdAllocationId: number }>>, adFiles: Array<{ __typename?: 'AdFile', size: string, adSetId: number, file?: Maybe<{ __typename?: 'File', url: string, id: number }> }> }>, config?: Maybe<{ __typename?: 'EntityAdAllocationConfig', events: any, teams: { __typename?: 'AdAllocationTeamConfig', home: { __typename?: 'TeamAllocationConfig', percentage: number, enabled: boolean }, away: { __typename?: 'TeamAllocationConfig', percentage: number, enabled: boolean } }, loop: { __typename?: 'AdAllocationLoopConfig', enabled: boolean, type: string, secsBetweenShows: number, secsPerShow: number, perPeriod: number } }> };

export type FactFragment = { __typename?: 'Fact', matchId: number, id: number, name: FactName, teamId?: Maybe<number>, playerId?: Maybe<number>, minute?: Maybe<number>, date: any, period: string, data?: Maybe<any> };

export type FileFragment = { __typename?: 'File', id: number, url: string, entityType: FileEntityType, entityId: number };

export type FootballStatsFragment = { __typename?: 'FootballStats', corners: number, fouls: number, goals: number, offsides: number, penaltiesMissed: number, penaltiesAwarded: number, freeKicks: number, possession: number, redCards: number, yellowCards: number, shotsOnTarget: number, shotsOffTarget: number, totalShots: number, substitutions: number };

export type PlaysForFragment = { __typename?: 'TeamWithPlayerPhoto', position?: Maybe<string>, positionType?: Maybe<string>, number?: Maybe<string>, defaultStarter: boolean, team: { __typename?: 'Team', id: number, name: string, abbreviation?: Maybe<string>, sport: { __typename?: 'Sport', id: number, name: string }, logo?: Maybe<{ __typename?: 'File', id: number, url: string }>, competitions: Array<{ __typename?: 'Competition', id: number, name: string, logo?: Maybe<{ __typename?: 'File', id: number, url: string }> }> }, photo?: Maybe<{ __typename?: 'File', id: number, url: string }> };

export type LeagueStatsFragment = { __typename?: 'RugbyLeagueStats', tries: number, points: number, conversions: number, penaltyGoals: number, dropGoals: number };

export type UnionStatsFragment = { __typename?: 'RugbyUnionStats', tries: number, tryAssists: number, conversions: number, conversionsMissed: number, penaltyGoals: number, penaltyGoalsMissed: number, penaltyTries: number, dropGoals: number, dropGoalsMissed: number, redCards: number, yellowCards: number, penaltiesConceded: number, kickCompGoals: number, kickCompGoalsMissed: number, turnoversConceded: number, scrums: number, scrumsConceded: number, lineouts: number, lineoutsConceded: number, rucks: number, rucksConceded: number, restarts: number, freeKicks: number, kicks: number, cleanBreaks: number, defenderBeatens: number, substitutions: number, possession: number };

export type TeamAdAllocationFragment = { __typename?: 'EntityAdAllocation', id: number, entityId: number, entity: { __typename?: 'Team', id: number, sport: { __typename?: 'Sport', id: number, name: string } } | { __typename?: 'Competition', id: number, sport: { __typename?: 'Sport', id: number, name: string } }, adSets: Array<{ __typename?: 'AdSet', id: number, name: string, teamId?: Maybe<number>, adSetAllocations?: Maybe<Array<{ __typename?: 'AdsetAllocation', id: number, percentage?: Maybe<number>, events?: Maybe<Array<string>>, entityAdAllocationId: number }>>, adFiles: Array<(
      { __typename?: 'AdFile' }
      & AdFileFragment
    )> }> };
